import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaPlus } from "react-icons/fa";
import "./Create-Investment.css";
import PerformanceSection from "./Performance-Graph";
import OtherDetails from "./Other-details";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import DocumentsSection from "./DocumentSection";
import AccessibleTable from "./member-table";
import { useSelector } from "react-redux";
import { useToast } from "../../Utils/toastContext";
import {
  resetDocumentId,
  addDocumentId,
} from "../../Redux/store/documentSlice";
import {
  resetSelectedUsers,
  addSelectedUsers,
} from "../../Redux/store/selectedUserSlice";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import DropdownTest from "./ndrop";
import { debounce } from "lodash";

const CreateInvestment = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const location = useLocation();
  const { from, investment_id, isNew } = location.state || {};
  const documentIds = useSelector((state) => state.documents.documentIds);
  const selecteduserIds = useSelector(
    (state) => state.selectedUsers.selectedUsers
  );
  const [loading, setLoading] = useState(false);
  const [isFirstManager, setIsFirstManager] = useState(false);
  const [isFirstCustodian, setIsFirstCustodian] = useState(false);

  const [isFirstAdvisor, setIsFirstAdvisor] = useState(false);
  const [isFirstAssetManager, setIsFirstAssetManager] = useState(false);

  const [isFirstSubAdvisor, setIsFirstSubAdvisor] = useState(false);
  const [isFirstPlatform, setIsFirstPlatform] = useState(false);

  const [isDropdownOpenTest, setIsDropdownOpenTest] = useState(false);
  const buttonRef = useRef(null);
  const searchRef = useRef();

  const toggleDropdownTest = () => setIsDropdownOpenTest((prev) => !prev);
  const quillRef = useRef(null);
  const dispatch = useDispatch();

  const [fundObjectives, setFundObjectives] = useState("");
  const [refId, setRefId] = useState("");
  const [australianCashStockId, setAustralianCashStockId] = useState("");
  const [deletedProduct, setDeletedProduct] = useState("");
  const [australianCashStockAllocation, setAustralianCashStockAllocation] =
    useState(0);

  const [investmentManagerfeePercentage, setinvestmentManagerfeePercentage] =
    useState(0);
  const [custodianFee, setCustodianFee] = useState(0);
  const [brokerageFee, setBrokerageFee] = useState(0);
  const [advisorfeePercentage, setadvisorfeePercentage] = useState(0);
  const [assetManagerfeePercentage, setAssetManagerfeePercentage] = useState(0);

  const [strategyType, setstrategyType] = useState("");
  const [riskProfile, setRiskProfile] = useState("");
  const [riskProfileData, setriskProfileData] = useState([]);
  const [strategyTypeData, setstrategyTypeData] = useState([]);
  const [productData, setProductData] = useState([]);

  const [riskRating, setriskRating] = useState("");
  const [investmentType, setinvestmentType] = useState("");
  const [investmentProductName, setinvestmentProductName] = useState("");
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [isAnyDropdownOpen, setisAnyDropdownOpen] = useState(false);
  const [growth, setGrowth] = useState(0);
  const [defensive, setDefensive] = useState(0);
  const getCurrentDate = () => {
    const today = new Date();
    today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // Adjust for timezone
    return today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  };
  const [creationDate, setCreationDate] = useState(getCurrentDate());
  const [investments, setInvestments] = useState([]);
  const [newInvestment, setNewInvestment] = useState("");
  const [categories, setCategories] = useState([]);
  const [newCategories, setNewCategories] = useState([]);
  const [actualCategories, setactualCategories] = useState([]);
  const [errors, setErrors] = useState({});
  const [totalErrors, setTotalErrors] = useState({});

  const [expandedCategory, setExpandedCategory] = useState({});
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [securityCodes, setSecurityCodes] = useState([]);
  const [productCodes, setproductCode] = useState([]);
  const [categoryCodes, setcategoryCodes] = useState([]);
  const [totalPortfolio, settotalPortfolio] = useState(0);
  const [users, setUsers] = useState([]);
  const [InvestmentManagerAccountData, setInvestmentManagerAccountData] =
    useState([]);
  const [custodianAccountData, setCustodianAccountData] = useState([]);
  const [InvestmentManagerAccount, setInvestmentManagerAccount] =
    useState(null);
  const [custodianAccountId, setCustodianAccountId] = useState(null);
  const [AdvisorAccountData, setAdvisorAccountData] = useState([]);
  const [AssetManagerAccountData, setAssetManagerAccountData] = useState([]);

  const [advisorAccount, setadvisorAccount] = useState(null);
  const [assetManagerAccountId, setAssetManagerAccountId] = useState(null);

  const [SubAdvisorAccountData, setSubAdvisorAccountData] = useState([]);
  const [subAdvisorAccount, setsubAdvisorAccount] = useState(null);
  const [SettlementAccountData, setSettlementAccountData] = useState([]);
  const [platformfeePercentage, setplatformfeePercentage] = useState(0);
  const [smaFees, setsmaFees] = useState(0);
  const [subAdvisorfeePercentage, setsubAdvisorfeePercentage] = useState(0);

  //Other details
  const [performanceNotes, setperformanceNote] = useState("");
  const [disclaimer, setdisclaimer] = useState("");
  const [copyrights, setcopyrights] = useState("");
  const [addToDashboard, setaddToDashboard] = useState(false);
  const [addMember, setaddMember] = useState(false);
  const [investmentManagerId, setInvestmentManagerId] = useState(null);
  const [advisorId, setadvisorId] = useState(null);
  const [assetManagerId, setAssetManagerId] = useState(null);
  const [subadvisorId, setSubadvisorId] = useState(null);
  const [newStrategyType, setnewStrategyType] = useState("");
  const [riskName, setRiskName] = useState("");
  const [riskNewRating, setRiskNewRating] = useState("");
  const [investCode, setInvestCode] = useState("");
  const [preselectedAddToDashboard, setPreselectedAddToDashboard] = useState(
    []
  );
  const [preselectedAddUser, setPreselectedAddUser] = useState([]);

  const [newRatingDefensive, setNewRatingDefensive] = useState("");
  const [newRiskGrowth, setNewRiskGrowth] = useState("");
  const [newStockCode, setNewStockCode] = useState("");
  const [newStockPrice, setNewStockPrice] = useState(0);
  const [strategyTypeId, setStrategyTypeId] = useState(null);

  const [stockName, setStockName] = useState("");
  const [productType, setProductType] = useState("");
  const [newStockExchange, setNewStockExchange] = useState("");
  const [volatility, setVolatility] = useState("");

  const [platformId, setPlatformId] = useState(null);
  const [platformWalletId, setPlatformwallet] = useState(null);
  const [preSelectedManagerAccount, setpreSelectedManagerAccount] = useState(
    {}
  );
  const [preselectedCustodian, setpreselectedCustodian] = useState({});
  const [preSelectedCustodianAccount, setpreSelectedCustodianAccount] =
    useState({});
  const [preSelectedManager, setpreSelectedManager] = useState({});
  const [preSelectedAdvisor, setpreSelectedAdvisor] = useState({});
  const [preSelectedAssetManager, setPreSelectedAssetManager] = useState({});

  const [searchTerm, setSearchTerm] = useState("");
  const [latestId, setLatestId] = useState(1);
  const [preSelectedSubAdvisor, setpreSelectedSubAdvisor] = useState({});
  const [preSelectedAdvisorAccount, setpreSelectedAdvisorAccount] = useState(
    {}
  );
  const [preSelectedAssetManagerAccount, setpreSelectedAssetManagerAccount] =
    useState({});
  const [custodianAvailable, setCustodianAvailable] = useState(null);

  const [preSelectedSubAdvisorAccount, setpreSelectedSubAdvisorAccount] =
    useState({});
  const [preselectedPlatform, setpreselectedPlatform] = useState({});
  const [preSelectedPlatformAccount, setpreSelectedPlatformAccount] = useState(
    {}
  );
  const [preSelectedStrategyType, setPreSelectedStrategyType] = useState({});
  const [preSelectedRiskProfile, setPreSelectedRiskProfile] = useState({});
  const [totalAllocationByCategory, settotalAllocationByCategory] = useState(
    []
  );
  const [isFocused, setIsFocused] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({});
  const isDropdownOpen = (categoryId, dropdownIndex) =>
    dropdownStates[`${categoryId}-${dropdownIndex}`] || false;

  const navigate = useNavigate();
  const [subAllocations, setSubAllocations] = useState([10, 10, 10]);
  let allocationErrors = [];
  let totalAllocationErrors = [];
  let twoPercentAllocationErrors = [];
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const [isOpenEditStock, setisOpenEditStock] = useState(false);
  const [twoPercentErrors, setTwoPercentErrors] = useState({});

  const inputRef = useRef(null);
  const volatilityData = [
    {
      value: "high",
      label: "High",
    },
    {
      value: "medium",
      label: "Medium",
    },
    {
      value: "low",
      label: "Low",
    },
  ];

  const handleSelectVolitalityType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setVolatility(selectedOption.value);
  };
  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setRiskName("");
    setRiskNewRating("");
    setNewRatingDefensive("");
    setNewRiskGrowth("");
    setnewStrategyType("");
  };

  const togglePopupEditStock = () => {
    setisOpenEditStock(!isOpenEditStock);
    setNewStockCode("");
    setStockName("");
    setProductType("");
    setNewStockExchange("");
    setVolatility("");
  };

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getUniqueRefId = async () => {
    try {
      const response = await GetAPIcalls("/v1/investment-portfolio/reference");

      if (response.status == 200) {
        setRefId(response.data.reference);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getUsers = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/user/customers`
          : "/v1/user/admin/users?customers=False"
      );

      if (response.status == 200) {
        const users = [];
        users.push({
          value: null,
          label: "N/A",
        });
        response.data.users.forEach((profile) => {
          users.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
        });
        setUsers(users);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getRiskProfile = async () => {
    try {
      let apiurl =
        strategyTypeId == 1
          ? "/v1/investment-portfolio/risk-profiles?type=single"
          : "/v1/investment/risk-profiles";
      const response = await GetAPIcalls(apiurl);

      if (response.status == 200) {
        const riskProfileData = [];
        response.data.risk_profiles.forEach((profile) => {
          riskProfileData.push({
            value: profile.id,
            label: profile.name,
            riskRating: profile.risk_rating,
            defensive: profile.defensive_percentage,
            growth: profile.growth_percentage,
          });
        });
        setriskProfileData(riskProfileData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getStrategyTypes = async () => {
    try {
      const response = await GetAPIcalls("/v1/investment/strategy-types");

      if (response.status == 200) {
        const strategyTypeData = [];
        response.data.strategy_types.forEach((profile) => {
          strategyTypeData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setstrategyTypeData(strategyTypeData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getProductTypes = async () => {
    try {
      const response = await GetAPIcalls("/v1/stock/products/all");

      if (response.status == 200) {
        const productData = [];
        response.data.forEach((profile) => {
          productData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setProductData(productData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const getWalletAccountsByManager = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${investmentManagerId}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            InvestmentManagerAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setInvestmentManagerAccountData(InvestmentManagerAccountData);
          if (!isFirstManager) {
            setpreSelectedManagerAccount(InvestmentManagerAccountData[0]);
            handleSelectInvestmentManagerAccount(
              InvestmentManagerAccountData[0]
            );
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setInvestmentManagerAccountData([]);
          setpreSelectedManagerAccount({});
          handleSelectInvestmentManagerAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByCustodian = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${custodianAvailable}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            InvestmentManagerAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setCustodianAccountData(InvestmentManagerAccountData);
          if (!isFirstCustodian) {
            setpreSelectedCustodianAccount(InvestmentManagerAccountData[0]);
            handleSelectCustodianAccount(InvestmentManagerAccountData[0]);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setCustodianAccountData([]);
          setpreSelectedCustodianAccount({});
          handleSelectCustodianAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByAdvisor = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${advisorId}/cash-accounts`
      );

      if (response.status == 200) {
        const AdvisorAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            AdvisorAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setAdvisorAccountData(AdvisorAccountData);
          if (!isFirstAdvisor) {
            setpreSelectedAdvisorAccount(AdvisorAccountData[0]);
            handleSelectAdvisorAccount(AdvisorAccountData[0]);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAdvisorAccountData([]);
          setpreSelectedAdvisorAccount({});
          handleSelectAdvisorAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByAssetManager = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${assetManagerId}/cash-accounts`
      );

      if (response.status == 200) {
        const AssetManagerAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            AssetManagerAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setAssetManagerAccountData(AssetManagerAccountData);
          if (!isFirstAssetManager) {
            setpreSelectedAssetManagerAccount(AssetManagerAccountData[0]);
            handleSelectAssetManagerAccount(AssetManagerAccountData[0]);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAssetManagerAccountData([]);
          setpreSelectedAssetManagerAccount({});
          handleSelectAssetManagerAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsBySubAdvisor = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${subadvisorId}/cash-accounts`
      );

      if (response.status == 200) {
        const SubAdvisorAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            SubAdvisorAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setSubAdvisorAccountData(SubAdvisorAccountData);
          if (!isFirstSubAdvisor) {
            setpreSelectedSubAdvisorAccount(SubAdvisorAccountData[0]);
            handleSelectSubAdvisorAccount(SubAdvisorAccountData[0]);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSubAdvisorAccountData([]);
          setpreSelectedSubAdvisorAccount({});
          handleSelectSubAdvisorAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCategoriesDraft = async () => {
    try {
      const response = await GetCategoryList();

      if (response.status == 200) {
        setactualCategories(response.data);
        generateSecurityCodesNew(response.data);
      } else {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const generateSecurityCodesNew = (categories) => {
    const securityCodes = [];

    categories.forEach((category) => {
      category.products.forEach((product) => {
        product.stocks.forEach((stock) => {
          securityCodes.push({
            stock: stock,
            categoryId: category.id,
            productId: product.id,
          });
        });
      });
    });
    setSecurityCodes(securityCodes);
  };
  const formatNumber = (value) => {
    if (!value) return "";
    // Remove non-numeric characters except dot
    const number = value.toString().replace(/,/g, "");
    return Number(number).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const handleChangeAmount = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setminimumInvestment(rawValue); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
  const updateTAAData = (taaData) => {
    const productCodes = [];
    const totalAllocationByCategory = [];
    let stockArray = [];
    let categoryProductMap = {};
    let newStockId = 1; // Use current ID
    taaData.forEach((category) => {
      category.products.forEach((product) => {
        product.stocks.forEach((stock) => {
          stockArray.push({
            product: product.id,
            id: newStockId++,
            code: stock.asx_code,
            name: stock.name,
            unitPrice: stock.unit_price,
            allocation: Number(stock.allocation).toFixed(2),
            stockId: stock.id,
            stockquantity: stock.quantity,
            stockMarketPrice: stock.market_value,
            productIndex: 0,
          });
          if (product.id == 9) {
            setAustralianCashStockAllocation(Number(stock.allocation));
            setAustralianCashStockId(newStockId - 1);
          }
        });

        productCodes.push({
          productId: product.id,
          allocation: Number(product.allocation).toFixed(2),
          categoryId: category.id,

          productName: product.name,
          productColour: product.color_code,
        });
      });

      totalAllocationByCategory.push({
        categoryId: category.id,
        allocation: Number(category.allocation),
      });
    });
    categoryProductMap = taaData.reduce((acc, category) => {
      const categoryId = category.id;
      const productIds = category.products.map((product) => product.id);

      acc[categoryId] = productIds;
      return acc;
    }, {});
    setSelectedProductsByCategory(categoryProductMap);
    setStocks(stockArray);
    setLatestId(stockArray.length + 1);
    setcategoryCodes(totalAllocationByCategory);
    setproductCode(productCodes);
    const totalportfolio = stockArray.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);
  };
  const getExistingData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/draft/${investment_id}`
      );

      if (response.status == 200) {
        setIsFirstManager(true);
        setIsFirstAdvisor(true);
        setIsFirstSubAdvisor(true);
        setIsFirstPlatform(true);
        setIsFirstAssetManager(true);
        setIsFirstCustodian(true);
        setRefId(response.data.investment_portfolio.basic_details.ref_id);
        setinvestmentType(
          response.data.investment_portfolio.basic_details.investment_type
        );
        // Manager details
        setInvestmentManagerId(
          response.data.investment_portfolio.basic_details.manager.id
        );
        const manager = users.find(
          (user) =>
            user.value ===
            response.data.investment_portfolio.basic_details.manager.id
        );
        setpreSelectedManager(manager);
        let InvestmentManagerAccountData = {
          value:
            response.data.investment_portfolio.basic_details.manager.account.id,
          label:
            response.data.investment_portfolio.basic_details.manager.account
              .name,
        };
        setpreSelectedManagerAccount(InvestmentManagerAccountData);
        handleSelectInvestmentManagerAccount(InvestmentManagerAccountData);
        setinvestmentManagerfeePercentage(
          response.data.investment_portfolio.basic_details.manager.account
            .fee_percentage
        );
        //Asset Manager
        if (
          response.data.investment_portfolio.basic_details.asset_manager != null
        ) {
          setAssetManagerId(
            response.data.investment_portfolio.basic_details.asset_manager.id
          );
          const assetManager = users.find(
            (user) =>
              user.value ===
              response.data.investment_portfolio.basic_details.asset_manager.id
          );
          setPreSelectedAssetManager(assetManager);
          let AssetManagerAccountData = {
            value:
              response.data.investment_portfolio.basic_details.asset_manager
                .account.id,
            label:
              response.data.investment_portfolio.basic_details.asset_manager
                .account.name,
          };
          setpreSelectedAssetManagerAccount(AssetManagerAccountData);
          handleSelectAssetManagerAccount(AssetManagerAccountData);
          setAssetManagerfeePercentage(
            response.data.investment_portfolio.basic_details.asset_manager
              .account.fee_percentage
          );
        }
        // custodian
        if (
          response.data.investment_portfolio.basic_details.custodian != null
        ) {
          setCustodianAvailable(
            response.data.investment_portfolio.basic_details.custodian.id
          );
          const custodian = users.find(
            (user) =>
              user.value ===
              response.data.investment_portfolio.basic_details.custodian.id
          );
          setpreselectedCustodian(custodian);
          let custodianaccount = {
            value:
              response.data.investment_portfolio.basic_details.custodian.account
                .id,
            label:
              response.data.investment_portfolio.basic_details.custodian.account
                .name,
          };
          setpreSelectedCustodianAccount(custodianaccount);
          handleSelectCustodianAccount(custodianaccount);
          setCustodianFee(
            response.data.investment_portfolio.basic_details.custodian.account
              .fee_percentage
          );
        }
        // Advisor details
        if (response.data.investment_portfolio.basic_details.advisor != null) {
          setadvisorId(
            response.data.investment_portfolio.basic_details.advisor.id
          );
          const advisor = users.find(
            (user) =>
              user.value ===
              response.data.investment_portfolio.basic_details.advisor.id
          );
          setpreSelectedAdvisor(advisor);
          let AdvisorAccountData = {
            value:
              response.data.investment_portfolio.basic_details.advisor.account
                .id,
            label:
              response.data.investment_portfolio.basic_details.advisor.account
                .name,
          };
          setpreSelectedAdvisorAccount(AdvisorAccountData);
          handleSelectAdvisorAccount(AdvisorAccountData);
          setadvisorfeePercentage(
            response.data.investment_portfolio.basic_details.advisor.account
              .fee_percentage
          );
        }
        // sub advisor
        if (
          response.data.investment_portfolio.basic_details.sub_advisor != null
        ) {
          setSubadvisorId(
            response.data.investment_portfolio.basic_details.sub_advisor.id
          );
          const subadvisor = users.find(
            (user) =>
              user.value ===
              response.data.investment_portfolio.basic_details.sub_advisor.id
          );
          setpreSelectedSubAdvisor(subadvisor);
          let SubAdvisorAccountData = {
            value:
              response.data.investment_portfolio.basic_details.sub_advisor
                .account.id,
            label:
              response.data.investment_portfolio.basic_details.sub_advisor
                .account.name,
          };
          setpreSelectedSubAdvisorAccount(SubAdvisorAccountData);
          handleSelectSubAdvisorAccount(SubAdvisorAccountData);
          setsubAdvisorfeePercentage(
            response.data.investment_portfolio.basic_details.sub_advisor.account
              .fee_percentage
          );
        }
        // platform
        if (response.data.investment_portfolio.basic_details.platform != null) {
          setPlatformId(
            response.data.investment_portfolio.basic_details.platform.id
          );
          const platform = users.find(
            (user) =>
              user.value ===
              response.data.investment_portfolio.basic_details.platform.id
          );
          setpreselectedPlatform(platform);
          let SettlementAccountData = {
            value:
              response.data.investment_portfolio.basic_details.platform.account
                .id,
            label:
              response.data.investment_portfolio.basic_details.platform.account
                .name,
          };
          setpreSelectedPlatformAccount(SettlementAccountData);
          handleSelectSettlementAccount(SettlementAccountData);
          setplatformfeePercentage(
            response.data.investment_portfolio.basic_details.platform.account
              .fee_percentage
          );
        }
        setFundObjectives(
          response.data.investment_portfolio.basic_details
            .fund_objective_and_process
        );
        setInvestCode(
          response.data.investment_portfolio.investment_details.invst_code
        );
        setinvestmentProductName(
          response.data.investment_portfolio.investment_details
            .investment_product_name
        );
        setriskRating(
          response.data.investment_portfolio.investment_details.risk_rating
        );
        setGrowth(
          response.data.investment_portfolio.investment_details
            .growth_percentage
        );

        setDefensive(
          response.data.investment_portfolio.investment_details
            .defensive_percentage
        );
        setInvestments(
          response.data.investment_portfolio.investment_details.investment_tags
        );
        setsmaFees(
          response.data.investment_portfolio.investment_details
            .sma_fee_percentage
        );
        setCreationDate(
          dayjs(
            response.data.investment_portfolio.investment_details
              .strategy_creation_date
          ).format("YYYY-MM-DD")
        );
        setminimumInvestment(
          response.data.investment_portfolio.investment_details
            .minimum_investment
        );
        setstrategyType(
          response.data.investment_portfolio.basic_details.strategy_type
        );
        setStrategyTypeId(
          response.data.investment_portfolio.basic_details.stategy_type_id
        );
        let strategyType = {
          value:
            response.data.investment_portfolio.basic_details.stategy_type_id,
          label: response.data.investment_portfolio.basic_details.strategy_type,
        };
        setPreSelectedStrategyType(strategyType);
        setRiskProfile(
          response.data.investment_portfolio.basic_details.risk_profile
        );
        let riskProfile = {
          value:
            response.data.investment_portfolio.basic_details.risk_profile_id,
          label: response.data.investment_portfolio.basic_details.risk_profile,
        };
        setPreSelectedRiskProfile(riskProfile);
        setperformanceNote(
          response.data.investment_portfolio.other_details
            .historic_performance_notes
        );
        setdisclaimer(
          response.data.investment_portfolio.other_details.disclaimer
        );
        setcopyrights(
          response.data.investment_portfolio.other_details.copy_rights
        );
        setaddToDashboard(response.data.investment_portfolio.add_to_dashboard);
        setaddMember(
          response.data.investment_portfolio.accessible_to_specific_customer
        );
        setPreselectedAddToDashboard({
          label:
            response.data.investment_portfolio.add_to_dashboard == true
              ? "Yes"
              : "No",
          value: response.data.investment_portfolio.add_to_dashboard,
        });

        setPreselectedAddUser({
          label:
            response.data.investment_portfolio
              .accessible_to_specific_customer == true
              ? "Yes"
              : "No",
          value:
            response.data.investment_portfolio.accessible_to_specific_customer,
        });
        for (
          let i = 0;
          i < response.data.investment_portfolio.specific_investors.length;
          i++
        ) {
          dispatch(
            addSelectedUsers(
              response.data.investment_portfolio.specific_investors[i]
            )
          );
        }
        for (
          let i = 0;
          i < response.data.investment_portfolio.documents.length;
          i++
        ) {
          dispatch(
            addDocumentId(response.data.investment_portfolio.documents[i])
          );
        }
        //target allocation table
        setNewCategories(
          response.data.investment_portfolio.allocations.allocation
        );
        updateTAAData(
          response.data.investment_portfolio.allocations.allocation
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        } else {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getRiskProfile();
    getStrategyTypes();
    getProductTypes();

    if (isNew == true && users.length > 0) {
      getUniqueRefId();
      dispatch(resetSelectedUsers());
      dispatch(resetDocumentId());
      getAllCategories(false);
    } else {
      if (users.length > 0) {
        getExistingData();
        getAllCategoriesDraft();
      }
    }
  }, [isNew, users]);
  useEffect(() => {
    getRiskProfile();
  }, [strategyTypeId]);
  useEffect(() => {
    getUsers();
  }, []);

  const getWalletAccountsByPlatform = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${platformId}/cash-accounts`
      );

      if (response.status == 200) {
        const SettlementAccountData = [];
        if (response.data.cash_accounts.length > 0) {
          response.data.cash_accounts.forEach((profile) => {
            SettlementAccountData.push({
              value: profile.id,
              label: profile.name,
            });
          });
          setSettlementAccountData(SettlementAccountData);
          if (!isFirstPlatform) {
            setpreSelectedPlatformAccount(SettlementAccountData[0]);
            handleSelectSettlementAccount(SettlementAccountData[0]);
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSettlementAccountData([]);
          setpreSelectedPlatformAccount({});
          handleSelectSettlementAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (investmentManagerId != null) {
      getWalletAccountsByManager();
    }
  }, [investmentManagerId]);
  useEffect(() => {
    if (custodianAvailable != null) {
      getWalletAccountsByCustodian();
    }
  }, [custodianAvailable]);
  useEffect(() => {
    if (advisorId != null) {
      getWalletAccountsByAdvisor();
    }
  }, [advisorId]);
  useEffect(() => {
    if (assetManagerId != null) {
      getWalletAccountsByAssetManager();
    }
  }, [assetManagerId]);
  useEffect(() => {
    if (subadvisorId != null) {
      getWalletAccountsBySubAdvisor();
    }
  }, [subadvisorId]);
  useEffect(() => {
    if (platformId != null) {
      getWalletAccountsByPlatform();
    }
  }, [platformId]);

  const handleSelectSettlementAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPlatformwallet(selectedOption.value);
  };
  const CustodianData = [
    { value: false, label: "No" },
    { value: true, label: "Yes" },
  ];
  const handleSelectCustodian = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCustodianAvailable(selectedOption.value);
    if (selectedOption.value == null) {
      setCustodianFee(0);
    }
    setIsFirstCustodian(false);
  };

  const handleSelectAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorAccount(selectedOption.value);
  };
  const handleSelectAssetManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setAssetManagerAccountId(selectedOption.value);
  };

  const handleSelectSubAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setsubAdvisorAccount(selectedOption.value);
  };
  const SubAdvisorData = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
  ];
  const handleSelectSubAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setSubadvisorId(selectedOption.value);
    if (selectedOption.value == null) {
      setsubAdvisorfeePercentage(0);
    }
    setIsFirstSubAdvisor(false);
  };
  const PlatformData = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
  ];
  const handleSelectPlatform = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPlatformId(selectedOption.value);
    if (selectedOption.value == null) {
      setplatformfeePercentage(0);
    }
    setIsFirstPlatform(false);
  };
  const handleSelectAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorId(selectedOption.value);
    if (selectedOption.value == null) {
      setadvisorfeePercentage(0);
    }
    setIsFirstAdvisor(false);
  };
  const handleSelectAssetManager = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setAssetManagerId(selectedOption.value);
    if (selectedOption.value == null) {
      setAssetManagerfeePercentage(0);
    }
    setIsFirstAssetManager(false);
  };
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerAccount(selectedOption.value);
  };
  const handleSelectCustodianAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCustodianAccountId(selectedOption.value);
  };
  const handleSelectInvestmentManager = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerId(selectedOption.value);
    if (selectedOption.value == null) {
      setinvestmentManagerfeePercentage(0);
    }
    setIsFirstManager(false);
  };
  const handleSelectStrategyType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setstrategyType(selectedOption.label);
    setStrategyTypeId(selectedOption.value);
    deleteAllProducts();
    setRiskProfile("");
    setGrowth(0);
    setDefensive(0);
    setriskRating("");
    setAustralianCashStockAllocation(0);
    setPreSelectedRiskProfile({});
    // if (selectedOption.value == 1) {
    //   deleteAllProducts();
    // }
  };
  const handleSelectProductType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setProductType(selectedOption.value);
  };
  const handleSelectriskProfile = (selectedOption) => {
    setRiskProfile(selectedOption.label);
    setGrowth(selectedOption.growth);
    setDefensive(selectedOption.defensive);
    setriskRating(selectedOption.riskRating);
    setAustralianCashStockAllocation(0);
    deleteAllProducts();
  };
  useEffect(() => {
    // Run validation whenever relevant state changes
    validateAllocation(stocks, productCodes, categoryCodes);
  }, [growth, defensive, stocks, productCodes, categoryCodes]);
  const toggleCategoryDropdown = (categoryId, dropdownIndex) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [`${categoryId}-${dropdownIndex}`]:
        !prevState[`${categoryId}-${dropdownIndex}`],
    }));
  };
  const totalSubAllocation = subAllocations.reduce(
    (acc, curr) => acc + curr,
    0
  );
  const [selectedProductsByCategory, setSelectedProductsByCategory] = useState(
    {}
  );
  const createInvestment = async (isSubmit) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/create`;
    let f = stocks;
    const investment_stocks = [];
    stocks.forEach((profile) => {
      investment_stocks.push({
        portfolio_product_id: profile.product,
        stock_id: profile.stockId,
        stock_allocation: Number(profile.allocation),
        stock_quantity: Math.round(profile.stockquantity),
        stock_unit_price: profile.unitPrice,
        stocks_market_price: profile.stockMarketPrice,
      });
    });
    const bodyData = {
      ref_id: refId,
      investment_manager_id: investmentManagerId,
      investment_manager_fee_percentage: Number(investmentManagerfeePercentage),
      investment_manager_sub_account_id: InvestmentManagerAccount,
      strategy_type: strategyType,
      advisor_id: advisorId,
      advisor_sub_account_id: advisorAccount,
      advisor_fee_percentage: Number(advisorfeePercentage),
      sub_advisor_id: Number(subadvisorId),
      sub_advisor_sub_account_id: subAdvisorAccount,
      sub_advisor_fee_percentage: Number(subAdvisorfeePercentage),
      risk_profile: riskProfile,
      investment_type: investmentType,
      fund_objective_and_process: fundObjectives,
      growth_percentage: growth,
      defensive_percentage: defensive,
      strategy_creation_date: creationDate,
      investment_product_name: investmentProductName,
      minimum_investment: Number(minimumInvestment),
      risk_rating: riskRating,
      historic_performance_note: performanceNotes,
      disclaimer: disclaimer,
      copy_rights: copyrights,
      add_to_dashboard: addToDashboard,
      accessible_to_specific_customer: addMember,
      tags: investments,
      investment_stocks: investment_stocks,
      document_ids: documentIds,
      specific_investor_ids: addMember == false ? [] : selecteduserIds,
      platform_id: platformId,
      platform_sub_account_id: platformWalletId,
      platform_fee_percentage: Number(platformfeePercentage),
      sma_fee_percentage: Number(smaFees),
      asset_manager_id: assetManagerId,
      asset_manager_sub_account_id: assetManagerAccountId,
      asset_manager_fee_percentage: Number(assetManagerfeePercentage),
      custodian_id: custodianAvailable,
      custodian_sub_account_id: custodianAccountId,
      custodian_fee_percentage: Number(custodianFee),
      submit: isSubmit,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  const handleCreateInvestment = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createInvestment(false);
        if (response.status == 201) {
          dispatch(resetDocumentId());
          dispatch(resetSelectedUsers());
          let redirectState = {
            path: "/investment-list",
            state: {
              from: location.pathname,
            },
          };
          sessionStorage.setItem(
            "redirectAfterLogin",
            JSON.stringify(redirectState)
          );
          navigate("/investment-list");
          toastMessage = { message: response.message, type: "success" };
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      minimumInvestment,
      strategyType,
      riskProfile,
      investmentManagerId,
      InvestmentManagerAccount,
      platformId,
      platformWalletId,
      stocks,
      errors,
      totalErrors,
      totalPortfolio,
      creationDate,
      custodianAvailable,
      refId,
      investmentManagerfeePercentage,
      advisorId,
      advisorAccount,
      advisorfeePercentage,
      subadvisorId,
      subAdvisorAccount,
      subAdvisorfeePercentage,
      riskProfile,
      investmentType,
      fundObjectives,
      growth,
      defensive,
      investmentProductName,
      minimumInvestment,
      riskRating,
      performanceNotes,
      disclaimer,
      copyrights,
      addToDashboard,
      addMember,
      investments,
      documentIds,
      selecteduserIds,
      platformId,
      platformWalletId,
      platformfeePercentage,
      smaFees,
      assetManagerId,
      assetManagerAccountId,
      assetManagerfeePercentage,
      custodianAvailable,
      custodianAccountId,
      custodianFee,
    ] // Dependencies
  );
  const createStrategyType = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/strategy-type`;
    const bodyData = {
      name: newStrategyType,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleCreatestrategyType = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createStrategyType(false);

        if (response.status == 200) {
          setisOpenEdit(false);
          getStrategyTypes();
          toastMessage = { message: "Added successfully", type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [newStrategyType] // Dependencies
  );
  const createRiskType = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/risk-profile`;
    const bodyData = {
      name: riskName,
      risk_rating: riskNewRating,
      growth_percentage: Number(newRiskGrowth),
      defensive_percentage: Number(newRatingDefensive),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const createNewStock = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/stock/create`;
    const bodyData = {
      name: stockName,
      asx_code: newStockCode,
      exchange: newStockExchange,
      volatility: volatility,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const LinkStockProduct = async (stockId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/stock/products/add-stock`;
    const bodyData = {
      product_id: productType,
      stock_id: stockId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  const handleRiskType = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createRiskType();
        if (response.status == 200) {
          setisOpenEdit(false);
          getRiskProfile();
          toastMessage = { message: "Added successfully", type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [newRiskGrowth, newRatingDefensive, riskName, riskNewRating] // Dependencies
  );
  const handleStockProductType = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createNewStock();
        if (response.status == 201) {
          const responseProduct = await LinkStockProduct(response.data.id);
          if (responseProduct.status == 201) {
            getAllCategories(true);
            togglePopupEditStock();
            toastMessage = {
              message: "New stock added successfully",
              type: "success",
            };
          } else {
            toastMessage = { message: responseProduct.message, type: "error" };
          }
        } else {
          showToast(response.message, "error");
        }
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [stockName, newStockCode, productType, newStockExchange, volatility] // Dependencies
  );

  const handleCreateAndSubmitInvestment = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createInvestment(true);
        if (response.status == 201) {
          dispatch(resetDocumentId());
          dispatch(resetSelectedUsers());
          let redirectState = {
            path: "/investment-list",
            state: {
              from: location.pathname,
            },
          };
          sessionStorage.setItem(
            "redirectAfterLogin",
            JSON.stringify(redirectState)
          );
          navigate("/investment-list");
          toastMessage = { message: response.message, type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      minimumInvestment,
      strategyType,
      riskProfile,
      investmentManagerId,
      InvestmentManagerAccount,
      platformId,
      platformWalletId,
      stocks,
      errors,
      totalErrors,
      totalPortfolio,
      creationDate,
      custodianAvailable,
      refId,
      investmentManagerfeePercentage,
      advisorId,
      advisorAccount,
      advisorfeePercentage,
      subadvisorId,
      subAdvisorAccount,
      subAdvisorfeePercentage,
      riskProfile,
      investmentType,
      fundObjectives,
      growth,
      defensive,
      investmentProductName,
      minimumInvestment,
      riskRating,
      performanceNotes,
      disclaimer,
      copyrights,
      addToDashboard,
      addMember,
      investments,
      documentIds,
      selecteduserIds,
      platformId,
      platformWalletId,
      platformfeePercentage,
      smaFees,
      assetManagerId,
      assetManagerAccountId,
      assetManagerfeePercentage,
      custodianAvailable,
      custodianAccountId,
      custodianFee,
    ]
  );
  const toggleProduct = (categoryId, productId) => {
    let v = selectedProductsByCategory[categoryId];
    if (
      productId != 9 &&
      selectedProductsByCategory[categoryId] != undefined &&
      selectedProductsByCategory[categoryId].length > 0 &&
      strategyTypeId == 1
    ) {
      showToast("You cannot add multiple asset category", "error");
      return;
    }
    if (productId != 9 && growth == Number(100) && categoryId == 2) {
      showToast(
        "You cannot add other categories except Australian Cash",
        "error"
      );
      return;
    }
    if (productId != 9 && defensive == Number(100) && categoryId == 1) {
      showToast("You cannot add growth", "error");
      return;
    }
    setSelectedProductsByCategory((prevState) => {
      const newState = { ...prevState };

      if (!newState[categoryId]) {
        newState[categoryId] = [];
      }

      // Check if the product is being removed
      if (newState[categoryId].includes(productId)) {
        // Store the removed product in a state variable (so we can restore it)
        setDeletedProduct({ categoryId, productId });

        // Remove the product from the list
        newState[categoryId] = newState[categoryId].filter(
          (id) => id !== productId
        );
      } else {
        // Add product to the category list
        newState[categoryId] = [...newState[categoryId], productId];
      }

      return newState;
    });
    if (productId == 9) {
      const category = newCategories.find((cat) =>
        cat.products.some((product) => product.id === 9)
      );

      const product = category?.products.find((product) => product.id === 9);
      const stock = product?.stocks.find((stock) => stock.id === 93) || {};
      handleAddItem(
        9,
        1,
        [
          {
            id: stock.id || null,
            asx_code: stock.asx_code || "",
            name: stock.name || "",
            exchange: stock.exchange || "",
            unit_price: stock.unit_price || 0,
          },
        ],
        0
      );
    }
    if (isNew == false) {
      const updatedCategories = addProductToExistingCategories(
        categoryId,
        productId
      );
      setNewCategories(updatedCategories);
    }
  };
  const updateProductCode = (productId, categoryId, newProduct) => {
    setproductCode((prevProductCodes) => {
      const updatedProductCodes = prevProductCodes.map((product) =>
        product.productId === productId
          ? {
              ...product,
              productName: newProduct.name,
              productColour: newProduct.color_code,
            }
          : product
      );

      // If productId doesn't exist, add a new entry
      const productExists = prevProductCodes.some(
        (product) => product.productId === productId
      );
      if (!productExists) {
        updatedProductCodes.push({
          productId,
          allocation: 0.0,
          categoryId,
          productName: newProduct.name,
          productColour: newProduct.color_code,
        });
      }

      return updatedProductCodes;
    });
  };
  const addProductToExistingCategories = (categoryId, productId) => {
    // Clone existingCategories to avoid mutations
    const updatedCategories = newCategories.map((category) => ({
      ...category,
      products: category.products.map((product) => ({
        ...product,
        stocks: product.stocks.map((stock) => ({ ...stock })), // Deep copy stocks
      })),
    }));
    // Find the corresponding category in existingCategories
    const categoryIndex = updatedCategories.findIndex(
      (cat) => cat.id === categoryId
    );

    if (categoryIndex !== -1) {
      const existingCategory = updatedCategories[categoryIndex];

      // Find the product in newCategories
      const newProduct = actualCategories
        .find((cat) => cat.id === categoryId)
        ?.products.find((prod) => prod.id === productId);
      const productCodes = [];
      if (newProduct) {
        // Check if the product already exists in existingCategories
        const productExists = existingCategory.products.some(
          (prod) => prod.id === productId
        );

        if (!productExists) {
          updateProductCode(productId, categoryId, newProduct);

          // Add the new product to the category
          existingCategory.products.push({
            ...newProduct,
            allocation: "0.00", // Initialize allocation
            stocks: newProduct.stocks.map((stock) => ({
              ...stock,
              allocation: "0.00", // Initialize stock allocation
              quantity: 0,
              market_price: 0,
            })),
          });

          console.log("Updated Categories:", updatedCategories);
        }
      }
    }

    return updatedCategories;
  };
  const deleteAllProducts = () => {
    setSelectedProductsByCategory((prevState) => {
      const newState = { ...prevState };

      // Loop through all categories and clear selected products
      Object.keys(newState).forEach((categoryId) => {
        if (newState[categoryId]) {
          newState[categoryId] = [];
        }
      });

      return newState;
    });

    // Clear stocks
    setStocks([]);

    // Reset portfolio total
    settotalPortfolio(0);
    const updatedProductAllocations = productCodes.map((product) => ({
      ...product,
      allocation: "0.00", // Set allocation to zero for all products
    }));

    // Update state with the new allocations
    // Validate allocation with empty stocks
    setproductCode(updatedProductAllocations);
    let totalAllocationByCategory = [];
    totalAllocationByCategory.push({
      categoryId: 1,
      allocation: 0,
    });
    totalAllocationByCategory.push({
      categoryId: 2,
      allocation: 0,
    });
    setcategoryCodes(totalAllocationByCategory);

    validateAllocation([], updatedProductAllocations, categoryCodes);
  };

  const DeleteProduct = (categoryId, productId) => {
    if (isNew == true) {
      setSelectedProductsByCategory((prevState) => {
        const newState = { ...prevState };

        if (!newState[categoryId]) {
          newState[categoryId] = [];
        }

        // Check if the product is being removed
        if (newState[categoryId].includes(productId)) {
          // Store the removed product in a state variable (so we can restore it)
          setDeletedProduct({ categoryId, productId });

          // Remove the product from the list
          newState[categoryId] = newState[categoryId].filter(
            (id) => id !== productId
          );
        } else {
          // Add product to the category list
          newState[categoryId] = [...newState[categoryId], productId];
        }

        return newState;
      });

      handleProductAllocationChange(productId, 0, categoryId, true);
      const updatedStocks = stocks.filter((item) => item.product !== productId);
      setStocks(updatedStocks);
      const totalportfolio = updatedStocks.reduce(
        (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
        0
      );
      settotalPortfolio(totalportfolio);
      if (productId == 9) {
        setAustralianCashStockAllocation(0);
      }
      validateAllocation(updatedStocks, productCodes, categoryCodes);
    } else {
      setSelectedProductsByCategory((prevState) => {
        const newState = { ...prevState };

        if (!newState[categoryId]) {
          newState[categoryId] = [];
        }

        // Check if the product is being removed
        if (newState[categoryId].includes(productId)) {
          // Store the removed product in a state variable (so we can restore it)
          // setDeletedProduct({ categoryId, productId });

          // Remove the product from the list
          newState[categoryId] = newState[categoryId].filter(
            (id) => id !== productId
          );
        } else {
          // Add product to the category list
          newState[categoryId] = [...newState[categoryId], productId];
        }

        return newState;
      });

      handleProductAllocationChange(productId, 0, categoryId, true);
      const updatedStocks = stocks.filter((item) => item.product !== productId);
      setStocks(updatedStocks);
      const totalportfolio = updatedStocks.reduce(
        (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
        0
      );
      settotalPortfolio(totalportfolio);
      if (productId == 9) {
        setAustralianCashStockAllocation(0);
      }
      validateAllocation(updatedStocks, productCodes, categoryCodes);
    }
  };
  const GetCategoryList = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/stock/categories/products`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllCategories = async (isNewStock) => {
    try {
      const response = await GetCategoryList();

      if (response.status == 200) {
        setNewCategories(response.data);
        generateSecurityCodes(response.data, isNewStock);
      } else {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [categoryExpanded, setcategoryExpanded] = useState([]);
  const buttonRefs = useRef({});
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        console.log("mousedown is wokring ");
        setDropdownOpen([]);
      }
    };

    window.addEventListener("scroll", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (itemIndex, subcategoryId) => {
    const key = `${subcategoryId}-${itemIndex}`;
    setDropdownOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
    setisAnyDropdownOpen(!isAnyDropdownOpen);
    setSearchTerm("");
  };
  const toggleExpandCategory = (categoryId) => {
    setExpandedCategory((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };
  const handleAddItem = (
    subcategory,
    categoryIndex,
    securityCodes,
    subcategoryIndex
  ) => {
    const newStockId = latestId; // Use current ID
    setLatestId(latestId + 1);
    setStocks([
      ...stocks,
      {
        product: subcategory,
        id: newStockId,
        code: securityCodes[0].asx_code,
        name: securityCodes[0].name,
        unitPrice: securityCodes[0].unit_price,
        allocation: "0.00",
        stockId: securityCodes[0].id,
        stockquantity: 0,
        stockMarketPrice: 0,
        productIndex: subcategoryIndex,
      },
    ]);
    if (subcategory == 9) {
      setAustralianCashStockId(newStockId);
    }
  };

  const deleteStock = (stockId, realId) => {
    const updatedStocks = stocks.filter((stock) => stock.id !== stockId);
    setStocks(updatedStocks);
    const totalportfolio = updatedStocks.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);
    if (realId === 93) {
      setAustralianCashStockAllocation(0);
    }
    validateAllocation(updatedStocks, productCodes, categoryCodes);
  };
  const generateSecurityCodes = (categories, isNewStock) => {
    const securityCodes = [];
    let securityIndex = 1;
    const productCodes = [];
    const totalAllocationByCategory = [];
    if (isNewStock) {
      categories.forEach((category) => {
        category.products.forEach((product) => {
          product.stocks.forEach((stock) => {
            securityCodes.push({
              stock: stock,
              categoryId: category.id,
              productId: product.id,
            });
          });
          productCodes.push({
            productId: product.id,
            allocation: "0.00",
            categoryId: category.id,

            productName: product.name,
            productColour: product.color_code,
          });
        });
        totalAllocationByCategory.push({
          categoryId: category.id,
          allocation: 0,
        });
      });
      // setcategoryCodes(totalAllocationByCategory);
      // setproductCode(productCodes);
      setSecurityCodes(securityCodes);
    } else {
      categories.forEach((category) => {
        category.products.forEach((product) => {
          product.stocks.forEach((stock) => {
            securityCodes.push({
              stock: stock,
              categoryId: category.id,
              productId: product.id,
            });
          });
          productCodes.push({
            productId: product.id,
            allocation: "0.00",
            categoryId: category.id,

            productName: product.name,
            productColour: product.color_code,
          });
        });
        totalAllocationByCategory.push({
          categoryId: category.id,
          allocation: 0,
        });
      });
      setcategoryCodes(totalAllocationByCategory);
      setproductCode(productCodes);
      setSecurityCodes(securityCodes);
    }
  };
  const updateStock = (productId, stockIndex, updatedStock) => {
    const productStocks = stocks.filter((stock) => stock.product === productId);
    if (productStocks.length > 0 && productStocks[stockIndex]) {
      const stockToUpdate = productStocks[stockIndex];
      stockToUpdate.code = updatedStock.asx_code || stockToUpdate.code;
      stockToUpdate.name = updatedStock.name || stockToUpdate.name;
      stockToUpdate.unitPrice =
        updatedStock.unit_price || stockToUpdate.unitPrice;
      stockToUpdate.allocation =
        stockToUpdate.stockId == 93 && stockToUpdate.allocation < 2
          ? 2
          : updatedStock.allocation || stockToUpdate.allocation;

      stockToUpdate.stockId = updatedStock.id || stockToUpdate.stockId;
      stockToUpdate.stockquantity =
        (stockToUpdate.allocation / 100) * minimumInvestment ||
        stockToUpdate.stockquantity;
      if (stockToUpdate.stockId == 93) {
        setAustralianCashStockAllocation(stockToUpdate.allocation);
      }
      stockToUpdate.stockMarketPrice =
        (Number(stockToUpdate.allocation) * Number(minimumInvestment)) / 100 ||
        stockToUpdate.stockMarketPrice;
      const updatedStocks = [...stocks];
      const productIndex = updatedStocks.findIndex(
        (stock) => stock.id === stockToUpdate.id
      );
      updatedStocks[productIndex] = stockToUpdate;

      console.log("Updated Stocks:", updatedStocks);
      return updatedStocks;
    }

    return stocks;
  };
  const [productAllocations, setProductAllocations] = useState(productCodes);

  const handleStockAllocationChange = (stockId, fromuser, stockIdReal) => {
    let newAllocation = "";
    if (fromuser == "") {
      newAllocation = "0";
    } else {
      newAllocation = fromuser;
    }
    if (stockIdReal == 93) {
      setAustralianCashStockAllocation(Number(newAllocation));
    }
    const updatedStocks = stocks.map((stock) =>
      stock.id === stockId
        ? {
            ...stock,
            allocation: newAllocation,
            stockquantity:
              (Number(newAllocation) / 100) * Number(minimumInvestment),
            stockMarketPrice:
              (Number(newAllocation) * Number(minimumInvestment)) / 100,
          }
        : stock
    );

    setStocks(updatedStocks);
    const totalportfolio = updatedStocks.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);

    validateAllocation(updatedStocks, productCodes, categoryCodes);
  };
  const handleProductAllocationChange = (
    productId,
    fromuser,
    categoryId,
    isDelete
  ) => {
    //   let newAllocation=0
    // if(newAllocationfrom==""){
    //   newAllocation="0"
    // }
    // else{
    //   newAllocation =newAllocationfrom
    // }
    // if (isDelete == false && productId == 9 && newAllocation < 2) {
    //   showToast("Australian cash allocation must be atleast 2%", "error");
    //   return;
    // }
    let newAllocation = "";
    if (fromuser == "") {
      newAllocation = "0";
    } else {
      newAllocation = fromuser;
    }
    if (productId == 9) {
      setAustralianCashStockAllocation(newAllocation);
      handleStockAllocationChange(australianCashStockId, newAllocation, 93);
    }
    const updatedProductAllocations = productCodes.map((product) =>
      product.productId === productId
        ? { ...product, allocation: newAllocation }
        : product
    );
    setproductCode(updatedProductAllocations);
    const totalAllocation = updatedProductAllocations
      .filter((code) => code.categoryId === categoryId)
      .reduce((sum, item) => sum + Number(item.allocation), 0);
    const updatedcCategoryAllocations = categoryCodes.map((product) =>
      product.categoryId === categoryId
        ? {
            ...product,
            allocation: parseFloat(Number(totalAllocation).toFixed(2)),
          }
        : product
    );
    // const totalportfolio = updatedProductAllocations.reduce(
    //   (sum, item) => sum + item.allocation,
    //   0
    // );
    setcategoryCodes(updatedcCategoryAllocations);
    // settotalPortfolio(totalportfolio);
    validateAllocation(
      stocks,
      updatedProductAllocations,
      updatedcCategoryAllocations
    );
  };
  const validateAllocation = (
    updatedStocks,
    updatedProductAllocations,
    updatedcCategoryAllocations
  ) => {
    totalAllocationErrors = [];
    allocationErrors = [];
    twoPercentAllocationErrors = [];
    const productTotalAllocations = updatedStocks.reduce((acc, stock) => {
      acc[stock.product] = (acc[stock.product] || 0) + Number(stock.allocation);
      return acc;
    }, {});
    for (const product of updatedProductAllocations) {
      if (
        product.productId != 9 &&
        (Number(product.allocation) > 0 ||
          Number(productTotalAllocations[product.productId]) > 0) &&
        Number(productTotalAllocations[product.productId]) !=
          Number(product.allocation)
      ) {
        allocationErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }
      if (product.productId == 9 && Number(product.allocation) < 2) {
        twoPercentAllocationErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }
    }
    for (const category of updatedcCategoryAllocations) {
      if (
        strategyTypeId != 1 &&
        category.categoryId == 1 &&
        growth != 100 &&
        category.allocation != growth
      ) {
        totalAllocationErrors[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${growth}%`;
      }
      if (
        strategyTypeId != 1 &&
        category.categoryId == 2 &&
        growth != 100 &&
        category.allocation != defensive
      ) {
        totalAllocationErrors[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${defensive}%`;
      }
      if (
        category.categoryId == 1 &&
        growth == 100 &&
        category.allocation != growth - australianCashStockAllocation
      ) {
        totalAllocationErrors[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${growth}%`;
      }
      if (
        category.categoryId == 2 &&
        growth != 100 &&
        category.allocation != defensive
      ) {
        totalAllocationErrors[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${defensive}%`;
      }
    }
    setTotalErrors(totalAllocationErrors);
    setErrors(allocationErrors);
    setTwoPercentErrors(twoPercentAllocationErrors);
  };
  const handleCodeChange = (
    itemIndex,
    subcategoryIndex,
    categoryIndex,
    newCode
  ) => {
    const selectedSecurity = securityCodes.find(
      (item) => item.stock.asx_code === newCode
    );
    let t = updateStock(
      selectedSecurity.productId,
      itemIndex,
      selectedSecurity.stock
    );
    setStocks(t);
  };
  const getRelevantSecurityCodes = (categoryId, subcategoryId) => {
    let test = securityCodes.filter(
      (code) =>
        code.categoryId === categoryId && code.productId === subcategoryId
    );
    return test;
  };

  const toggleExpandSubcategory = (categoryName, subcategoryName) => {
    setCategories((prevCategories) =>
      prevCategories.map((category) =>
        category.name === categoryName
          ? {
              ...category,
              subcategories: category.subcategories.map((subcategory) =>
                subcategory.name === subcategoryName
                  ? { ...subcategory, expanded: !subcategory.expanded }
                  : subcategory
              ),
            }
          : category
      )
    );
  };
  const handleAddSubcategory = (categoryName) => {
    setCategories((prev) =>
      prev.map((cat) =>
        cat.name === categoryName
          ? {
              ...cat,
              subcategories: [
                ...cat.subcategories,
                {
                  name: `Subcategory ${cat.subcategories.length + 1}`,
                  allocation: 0,
                  expanded: false,
                  items: [],
                },
              ],
            }
          : cat
      )
    );
  };

  const handleChange = (value) => {
    setFundObjectives(value);
  };
  const handleAddInvestment = (e) => {
    if (e.key === "Enter" && newInvestment.trim() !== "") {
      setInvestments([...investments, newInvestment.trim()]);
      setNewInvestment("");
    }
  };

  const handleRemoveInvestment = (indexToRemove) => {
    setInvestments(investments.filter((_, index) => index !== indexToRemove));
  };
  const handleScroll = (indexToRemove) => {
    console.log("I xan scroll");
    setDropdownOpen([]);
  };
  useEffect(() => {
    if (dropdownOpen != null) {
      console.log("Dropdown for create opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log(
        "Dropdown for create closed, removing scroll event listener."
      );
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dropdownOpen]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (
        isOutside &&
        searchRef.current &&
        !searchRef.current.contains(event.target)
      ) {
        setDropdownOpen([]); // Close dropdown if clicked outside
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <div>
      <div onScroll={handleScroll} className="mx-auto overflow-x-auto">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-6">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/card-add.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Create Portfolio</h1>
          </div>
          <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
            <h1 className="text-md font-medium mb-2 text-black text-center">
              Basic Details
            </h1>
            <img
              onClick={togglePopupEdit}
              src="/edit-details.svg" // Replace with the actual path to your edit icon
              alt="Edit Icon"
              className="w-4 h-4 cursor-pointer"
            />
          </div>
          {isOpenEdit && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg w-[70%] md:w-[500px] p-6">
                {/* Modal Header */}
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg font-medium text-center w-full">
                    Add More
                  </h2>
                  <button onClick={togglePopupEdit}>
                    <img src="/add.svg" alt="Close" className="w-10 h-10" />
                  </button>
                </div>

                {/* Modal Body */}
                <div className="grid grid-cols-1 gap-2 items-center">
                  <div className="space-y-2 mx-auto max-w-sm w-full">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 mt-4 text-sm text-labelColour block"
                    >
                      Strategy Type
                    </label>
                    <input
                      id="investmentType"
                      type="text"
                      value={newStrategyType}
                      onChange={(e) => setnewStrategyType(e.target.value)}
                      className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                      placeholder="SMA"
                    />
                  </div>
                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (newStrategyType == "") {
                          showToast("Please fill all fields", "error");
                          return;
                        }
                        setLoading(true);
                        handleCreatestrategyType(e);
                      }}
                      className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Add Strategy Type
                    </button>
                  </div>
                  {/* Risk type */}
                  <div className="space-y-2 mx-auto max-w-sm w-full">
                    <label
                      htmlFor="riskName"
                      className="mb-1 mt-4 text-sm text-labelColour block"
                    >
                      Risk Name
                    </label>
                    <input
                      id="riskName"
                      type="text"
                      value={riskName}
                      onChange={(e) => setRiskName(e.target.value)}
                      className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                      placeholder=""
                    />
                    <label
                      htmlFor="riskNewRating"
                      className="mb-1 mt-4 text-sm text-labelColour block"
                    >
                      Risk Rating
                    </label>
                    <input
                      id="riskNewRating"
                      type="text"
                      value={riskNewRating}
                      onChange={(e) => setRiskNewRating(e.target.value)}
                      className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                      placeholder="SMA"
                    />

                    {/* Growth and Defensive Fields */}
                    <div className="flex flex-wrap gap-4">
                      <div className="flex-1 min-w-[45%]">
                        <label className="block text-sm text-[#464646]">
                          Growth (%)
                        </label>
                        <div className="relative">
                          <input
                            type="number"
                            value={newRiskGrowth}
                            onChange={(e) => setNewRiskGrowth(e.target.value)}
                            className="mt-1 block p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                          />
                          <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                            %
                          </span>
                        </div>
                      </div>
                      <div className="flex-1 min-w-[45%]">
                        <label className="block text-sm text-[#464646]">
                          Defensive (%)
                        </label>
                        <div className="relative">
                          <input
                            type="number"
                            value={newRatingDefensive}
                            onChange={(e) =>
                              setNewRatingDefensive(e.target.value)
                            }
                            className="mt-1 block p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                          />
                          <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                            %
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          riskName === "" ||
                          riskNewRating === "" ||
                          newRiskGrowth === "" ||
                          newRatingDefensive === "" ||
                          (Number(newRiskGrowth) === 100 &&
                            Number(newRatingDefensive) !== 0) ||
                          (Number(newRatingDefensive) === 100 &&
                            Number(newRiskGrowth) !== 0)
                        ) {
                          showToast("Please fill all fields", "error");
                          return;
                        }
                        setLoading(true);
                        handleRiskType(e);
                      }}
                      className="px-8 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Add Risk Profile
                    </button>
                  </div>
                </div>

                {/* Modal Footer */}
              </div>
            </div>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4">
              <label htmlFor="refId" className="mb-1 text-sm text-labelColour">
                Ref ID
              </label>
              <input
                id="refId"
                type="text"
                value={refId}
                disabled={true}
                className="bg-[#F9F9F9] p-2 text-black font-medium rounded-md text-md"
                placeholder="INV1947534324"
              />
              <div className="mt-4">
                <Dropdown
                  label="Strategy Type"
                  options={strategyTypeData}
                  preselectedValue={preSelectedStrategyType}
                  onSelect={handleSelectStrategyType}
                />
              </div>
              {strategyTypeId && (
                <div className="mt-4">
                  <Dropdown
                    label="Risk Profile"
                    options={riskProfileData}
                    preselectedValue={preSelectedRiskProfile}
                    onSelect={handleSelectriskProfile}
                  />
                </div>
              )}
              <label
                htmlFor="investmentType"
                className="mb-1 mt-4 text-sm text-labelColour"
              >
                Investment Type
              </label>
              <input
                id="investmentType"
                type="text"
                value={investmentType}
                onChange={(e) => setinvestmentType(e.target.value)}
                className="p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                placeholder="SMA"
              />
              <div className="mt-4">
                <Dropdown
                  label="Custodian"
                  options={users}
                  search={true}
                  preselectedValue={preselectedCustodian}
                  onSelect={handleSelectCustodian}
                />
              </div>
              {custodianAvailable && (
                <div className="mt-4">
                  <Dropdown
                    label="Custodian account"
                    options={custodianAccountData}
                    preselectedValue={preSelectedCustodianAccount}
                    onSelect={handleSelectCustodianAccount}
                  />
                </div>
              )}

              <label
                htmlFor="custodianFee"
                className="mb-1 mt-4 text-left text-sm"
              >
                <div className="text-labelColour">
                  Custody Fees %
                  <br />
                  <div className="text-[#868686] text-xs mt-1">
                    Weighted Average
                  </div>
                </div>
              </label>
              <div className="relative">
                <input
                  type="number"
                  name="field1"
                  max={99}
                  value={custodianFee}
                  disabled={custodianAvailable == null ? true : false}
                  onChange={(e) => setCustodianFee(e.target.value)}
                  placeholder="Enter value"
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                />
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                  <span className="text-gray-500">%</span>
                </div>
              </div>

              <label htmlFor="smaFees" className="block mt-4 mb-1 text-sm">
                <span className="text-labelColour"> SMA Fees %</span>
                <br />
                <span className="text-[#868686] text-xs">Including GST</span>
              </label>
              <div className="relative">
                <input
                  type="number"
                  value={smaFees}
                  onChange={(e) => setsmaFees(e.target.value)}
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                  %
                </span>
              </div>
            </div>
            {/* center column */}
            <div className="flex flex-col lg:pt-4 pt-0 text-left sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
              <div className="mt-0">
                <Dropdown
                  label="Investment Manager"
                  options={users}
                  preselectedValue={preSelectedManager}
                  onSelect={handleSelectInvestmentManager}
                  search={true}
                />
              </div>
              <label
                htmlFor="investmentManagerFees"
                className="mb-1 mt-4 text-left text-sm"
              >
                <div className="text-labelColour">
                  Investment Manager Fees %
                  <br />
                  <div className="text-[#868686] text-xs mt-1">
                    Weighted Average
                  </div>
                </div>
              </label>

              <div className="relative">
                <input
                  type="number"
                  name="field1"
                  max={99}
                  value={investmentManagerfeePercentage}
                  disabled={investmentManagerId == null ? true : false}
                  onChange={(e) =>
                    setinvestmentManagerfeePercentage(e.target.value)
                  }
                  placeholder="Enter value"
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                />
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                  <span className="text-gray-500">%</span>
                </div>
              </div>

              {investmentManagerId != null && (
                <div className="mt-4">
                  <Dropdown
                    label="Investment Manager Settlement account"
                    options={InvestmentManagerAccountData}
                    preselectedValue={preSelectedManagerAccount}
                    onSelect={handleSelectInvestmentManagerAccount}
                  />
                </div>
              )}
              <div className="mt-4">
                <Dropdown
                  label="Select Advisor"
                  options={users}
                  preselectedValue={preSelectedAdvisor}
                  onSelect={handleSelectAdvisor}
                  search={true}
                />
              </div>
              <label
                htmlFor="investmentManagerFees"
                className="mt-4 mb-1 text-sm"
              >
                <div className="text-labelColour">
                  {" "}
                  Advisor Fees %
                  <br />
                  <div className="text-[#868686] text-xs mt-1">
                    Weighted Average
                  </div>
                </div>
              </label>
              <div className="relative">
                <input
                  type="number"
                  name="field2"
                  max={99}
                  value={advisorfeePercentage}
                  disabled={advisorId == null ? true : false}
                  onChange={(e) => setadvisorfeePercentage(e.target.value)}
                  placeholder="Enter value"
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                />
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                  <span className="text-gray-500">%</span>
                </div>
              </div>
              {advisorId != null && (
                <div className="mt-4">
                  <Dropdown
                    label=" Advisor Settlement account"
                    options={AdvisorAccountData}
                    preselectedValue={preSelectedAdvisorAccount}
                    onSelect={handleSelectAdvisorAccount}
                  />
                </div>
              )}
              <div className="mt-4">
                <Dropdown
                  label="Sub Advisor"
                  options={users}
                  search={true}
                  preselectedValue={preSelectedSubAdvisor}
                  onSelect={handleSelectSubAdvisor}
                />
              </div>
              {subadvisorId != null && (
                <div className="mt-4">
                  <Dropdown
                    label="Sub Advisor Settlemment Account"
                    options={SubAdvisorAccountData}
                    preselectedValue={preSelectedSubAdvisorAccount}
                    onSelect={handleSelectSubAdvisorAccount}
                  />
                </div>
              )}
            </div>
            {/* Left column */}
            <div className="flex lg:pt-4 pt-0 flex-col px-4">
              <label htmlFor="investmentManagerFees" className=" mb-1 text-sm">
                <div className="text-labelColour">
                  {" "}
                  Sub Advisor Fees %
                  <br />
                  <div className="text-[#868686] text-xs mt-1">
                    Weighted Average
                  </div>
                </div>
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="field1"
                  placeholder="Enter value"
                  value={subAdvisorfeePercentage}
                  disabled={subadvisorId == null ? true : false}
                  onChange={(e) => setsubAdvisorfeePercentage(e.target.value)}
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                />
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                  <span className="text-gray-500">%</span>
                </div>
              </div>
              <div className="mt-4">
                <Dropdown
                  label="Platform"
                  options={users}
                  search={true}
                  preselectedValue={preselectedPlatform}
                  onSelect={handleSelectPlatform}
                />
              </div>
              {platformId != null && (
                <div className="mt-4">
                  <Dropdown
                    label="Settlement account"
                    options={SettlementAccountData}
                    preselectedValue={preSelectedPlatformAccount}
                    onSelect={handleSelectSettlementAccount}
                  />
                  <label
                    htmlFor="investmentManagerFees"
                    className="mt-2 mb-1 text-sm"
                  >
                    <div className="text-labelColour">
                      {" "}
                      Includes a standard platform fee.
                    </div>
                  </label>
                </div>
              )}
              {/* <label
                htmlFor="investmentManagerFees"
                className="mt-4 mb-1 text-sm"
              >
                <div className="text-labelColour">
                  {" "}
                  Platform Fees%
                  <br />
                  <div className="text-[#868686] text-xs mt-1">
                    Weighted Average
                  </div>
                </div>
              </label>
              <div className="relative">
                <input
                  type="text"
                  name="field1"
                  value={platformfeePercentage}
                  disabled={platformId == null ? true : false}
                  onChange={(e) => setplatformfeePercentage(e.target.value)}
                  placeholder="Enter value"
                  className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                />
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                  <span className="text-gray-500">%</span>
                </div>
              </div> */}
              <div className="mt-4">
                <Dropdown
                  label="Select Asset Manager"
                  options={users}
                  search={true}
                  preselectedValue={preSelectedAssetManager}
                  onSelect={handleSelectAssetManager}
                />
              </div>
              <div>
                <label
                  htmlFor="investmentManagerFees"
                  className="mt-4 mb-1 text-sm"
                >
                  <div className="text-labelColour">
                    {" "}
                    Asset Manager Fees %
                    <br />
                    <div className="text-[#868686] text-xs mt-1">
                      Weighted Average
                    </div>
                  </div>
                </label>
                <div className="relative">
                  <input
                    type="number"
                    name="field2"
                    max={99}
                    disabled={assetManagerId == null ? true : false}
                    value={assetManagerfeePercentage}
                    onChange={(e) =>
                      setAssetManagerfeePercentage(e.target.value)
                    }
                    placeholder="Enter value"
                    className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                  />
                  <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                    <span className="text-gray-500">%</span>
                  </div>
                </div>
              </div>
              {assetManagerId != null && (
                <div className="mt-4">
                  <Dropdown
                    label="Asset Manager account"
                    options={AssetManagerAccountData}
                    preselectedValue={preSelectedAssetManagerAccount}
                    onSelect={handleSelectAssetManagerAccount}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Fund Objective & Process Section */}
          <div className="mt-6 px-4">
            <label
              htmlFor="fundObjective"
              className="block mb-1 text-sm text-gray-700"
            >
              Fund Objective & Process
            </label>
            <ReactQuill
              ref={quillRef}
              className="bg-white border overflow-hidden rounded-xl"
              value={fundObjectives}
              onChange={handleChange}
              theme="snow"
              placeholder="Enter fund objectives and process here..."
            />
          </div>
        </div>

        {/* Investment details */}
        <div className="p-6 mt-6 bg-white shadow-md rounded-md">
          <div className="flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
            <h1 className="text-lg font-semibold mb-2 text-black text-center">
              Investment Details
            </h1>
          </div>{" "}
          <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
            {/* Left Column */}
            <div className="space-y-4 pt-4 px-4">
              {/* Code */}
              <div>
                <label htmlFor="code" className="mb-1 text-sm text-labelColour">
                  Code
                </label>{" "}
                <input
                  id="code"
                  type="text"
                  value={investCode}
                  disabled={true}
                  className="bg-[#F9F9F9] block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="CT0291288"
                />
              </div>

              {/* Investment Product Name */}
              <div>
                <label className="block mb-1 mt-4 text-sm text-labelColour ">
                  Investment Product Name
                </label>
                <input
                  type="text"
                  value={investmentProductName}
                  onChange={(e) => setinvestmentProductName(e.target.value)}
                  className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                />
              </div>

              {/* Risk Rating */}
              <div>
                <label
                  htmlFor="riskRating"
                  className="mb-1 text-sm text-labelColour"
                >
                  Risk Rating
                </label>{" "}
                <input
                  id="riskRating"
                  type="text"
                  value={riskRating}
                  disabled={true}
                  className="bg-[#F9F9F9] block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="CT0291288"
                />
              </div>
            </div>

            {/* Center Column with Border */}
            <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
              {/* Growth and Defensive in one row */}
              <div className="grid grid-cols-2 gap-4">
                {/* Growth (%) */}
                <div>
                  <label className="block text-sm text-[#464646]">
                    Growth (%)
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={growth}
                      disabled={true}
                      onChange={(e) => setGrowth(e.target.value)}
                      className="mt-1 block p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                      %
                    </span>
                  </div>
                </div>

                {/* Defensive (%) */}
                <div>
                  <label className="block text-sm text-[#464646]">
                    Defensive (%)
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={defensive}
                      disabled={true}
                      onChange={(e) => setDefensive(e.target.value)}
                      className="p-2 mt-1 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                      %
                    </span>
                  </div>
                </div>
              </div>

              {/* Investments */}
              <div>
                <label className="block mb-1 mt-4 text-sm text-[#464646]">
                  Investments
                </label>
                <div className="mt-1 border rounded-md border-gray-300 p-2 flex flex-wrap gap-2">
                  {investments.map((investment, index) => (
                    <div
                      key={index}
                      className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                    >
                      <span>{investment}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveInvestment(index)}
                        className="ml-2 text-gray-700 hover:text-gray-700"
                      >
                        &times;
                      </button>
                    </div>
                  ))}
                  <input
                    type="text"
                    value={newInvestment}
                    onChange={(e) => setNewInvestment(e.target.value)}
                    onKeyDown={handleAddInvestment}
                    placeholder="Add investment"
                    className="border-none focus:outline-none flex-grow text-sm"
                  />
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4 px-4 pt-4">
              {/* Strategy Creation Date */}
              <div>
                <label className="block mb-1 w-full text-sm text-[#464646]">
                  Strategy Inception Date
                </label>
                <input
                  type="date"
                  value={creationDate}
                  onChange={(e) => setCreationDate(e.target.value)}
                  className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                />
              </div>

              {/* Minimum Investment Amount */}
              <div>
                <label className="block  mb-1 text-sm text-labelColour">
                  Minimum Investment Amount
                </label>
                <div className="flex items-center mt-2 border border-gray-300 rounded-md overflow-hidden">
                  <span className="px-2 text-gray-500 font-medium">$</span>
                  <input
                    type="text"
                    name="field2"
                    value={
                      isFocused
                        ? minimumInvestment
                        : formatNumber(minimumInvestment)
                    }
                    ref={inputRef}
                    onChange={(e) => {
                      if (!isFocused) return;
                      handleChangeAmount(e, e.target.value);
                      const updatedStocks = stocks.map((stock) => ({
                        ...stock,
                        stockquantity:
                          (stock.allocation / 100) * Number(e.target.value),
                        stockMarketPrice:
                          (Number(stock.allocation) *
                            Number(minimumInvestment)) /
                          100,
                      }));
                      setStocks(updatedStocks);
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    className="p-2 w-full text-black font-medium outline-none text-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {riskProfile && Number(minimumInvestment) > 0 && isNew == true && (
          <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
              <h1 className="text-lg font-medium mb-2 text-black text-center">
                Current Target Allocation
              </h1>
              <img
                onClick={togglePopupEditStock}
                src="/edit-details.svg" // Replace with the actual path to your edit icon
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            {isOpenEditStock && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[70%] md:w-[500px] p-6">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Add New Stock
                    </h2>
                    <button onClick={togglePopupEditStock}>
                      <img src="/add.svg" alt="Close" className="w-10 h-10" />
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex flex-col mx-auto max-w-sm w-full">
                      <label
                        htmlFor="stockCode"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Stock Code
                      </label>
                      <input
                        id="stockCode"
                        type="text"
                        value={newStockCode}
                        onChange={(e) => setNewStockCode(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder="SMA"
                      />
                      <label
                        htmlFor="stockName"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Stock Name
                      </label>
                      <input
                        id="stockName"
                        type="text"
                        value={stockName}
                        onChange={(e) => setStockName(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder=""
                      />
                      <div className="mt-4">
                        <Dropdown
                          label="Volatility"
                          options={volatilityData}
                          onSelect={handleSelectVolitalityType}
                        />
                      </div>
                    </div>
                    {/* Risk type */}
                    <div className="flex flex-col mx-auto max-w-sm w-full">
                      <div className="mt-4">
                        <Dropdown
                          label="Product"
                          options={productData}
                          onSelect={handleSelectProductType}
                        />
                      </div>
                      <label
                        htmlFor="stockExchange"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Exchange
                      </label>
                      <input
                        id="stockExchange"
                        type="text"
                        value={newStockExchange}
                        onChange={(e) => setNewStockExchange(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder="SMA"
                      />
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          newStockCode == "" ||
                          stockName == "" ||
                          productType == "" ||
                          newStockExchange == "" ||
                          volatility == ""
                        ) {
                          showToast("Please fill all fields", "error");
                          return;
                        }
                        setLoading(true);
                        handleStockProductType(e);
                      }}
                      className="px-8 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Add Stock
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Table Header */}
            <div className="overflow-x-auto ml-4 mb-4">
              <table className=" w-full table-auto border-collapse">
                <thead>
                  <tr className="pl-14">
                    <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                      No
                    </th>
                    <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                      Security (Code)
                    </th>
                    <th className="py-2 px-2 text-sm w-60 font-medium text-[#8C8C8C] border-b">
                      Name
                    </th>
                    <th className="py-2 pl-10  text-sm font-medium text-[#8C8C8C] border-b">
                      Allocation (%)
                    </th>
                    <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b">
                      Market Price (AUD)
                    </th>
                  </tr>
                </thead>
              </table>
            </div>

            {/* Categories */}
            {newCategories.map((category, categoryIndex) => (
              <div key={category.id} className="mb-2">
                <div
                  className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                    category.id === 2 ? "bg-[#A9D4AB]" : "bg-[#92C5EA]"
                  }`}
                >
                  <div
                    className="flex items-center flex-grow cursor-pointer"
                    onClick={() => toggleExpandCategory(category.id)}
                  >
                    <span className="text-sm md:text-lg font-bold text-black">
                      {category.name}{" "}
                      <span className="font-medium">
                        {category.id === 2
                          ? `(${defensive.toFixed(2)}%)`
                          : `(${growth.toFixed(2)}%)`}
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="relative mt-2">
                      <button
                        onClick={() =>
                          toggleCategoryDropdown(category.id, categoryIndex)
                        }
                        className={`flex items-center text-sm text-white p-3 rounded-xl transition-all ${
                          category.id === 2 ? "bg-[#709D72]" : "bg-[#63859F] "
                        }`}
                      >
                        <FaPlus className="mr-2 " /> Add Asset Category{" "}
                      </button>
                      {isDropdownOpen(category.id, categoryIndex) && (
                        <div className="absolute z-50 mt-2 bg-white border rounded-md shadow-lg w-full">
                          {category.products
                            .filter(
                              (p) =>
                                !(
                                  selectedProductsByCategory[category.id] || []
                                ).includes(p.id)
                            )
                            .map((filteredProduct) => (
                              <div
                                key={filteredProduct.id}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => {
                                  toggleCategoryDropdown(
                                    category.id,
                                    categoryIndex
                                  );
                                  toggleProduct(
                                    category.id,
                                    filteredProduct.id
                                  );
                                  if (!expandedCategory[category.id]) {
                                    toggleExpandCategory(category.id);
                                  }
                                }}
                              >
                                {filteredProduct.name}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                    <span
                      className="cursor-pointer lg:ml-4 ml-0"
                      onClick={() => toggleExpandCategory(category.id)}
                    >
                      {expandedCategory[category.id] ? (
                        <img
                          src="/export-arrow.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>

                {/* Subcategories */}
                <div
                  className={`ml-4 md:ml-6 border-l-2 ${
                    category.id === 2 ? "border-[#A9D4AB]" : "border-[#92C5EA]"
                  }`}
                >
                  {category.products
                    .filter((product) =>
                      (selectedProductsByCategory[category.id] || []).includes(
                        product.id
                      )
                    )
                    .map((subcategory, subcategoryIndex) => (
                      <div
                        key={subcategory.name}
                        className="relative mb-2 pt-2 text-left"
                      >
                        {/* Subcategory Header */}
                        <div className="flex items-center justify-start  rounded-md cursor-pointer">
                          {category.id === 2 ? (
                            <img
                              src="/green-arrow.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          ) : (
                            <img
                              src="/arrow-hierarchy.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          )}

                          <div
                            className={`flex items-center justify-between p-4 w-full  rounded-md cursor-pointer ${
                              category.id === 2
                                ? "bg-[#C0E2C1]"
                                : "bg-[#C6DFF1] "
                            }`}
                          >
                            <div
                              key={subcategory.name}
                              className="flex flex-wrap md:flex-nowrap items-center justify-between w-full space-y-4 md:space-y-0 md:space-x-6"
                            >
                              {/* Subcategory Name */}
                              <div
                                className={`text-sm md:text-lg w-full custom-create-margin md:w-1/3 font-bold text-black 
    ${strategyTypeId == 1 ? "md:mr-[7.5vw] new-ml" : "md:mr-[7vw] ml-st "}`}
                              >
                                {`${subcategoryIndex + 1}. ${subcategory.name}`}
                              </div>

                              {/* Empty Placeholder for Alignment */}
                              <div className="hidden md:block text-md font-bold text-black"></div>

                              {/* Input Field with Percentage */}
                              <div className="w-full md:w-auto relative">
                                {productCodes
                                  .filter(
                                    (item) => subcategory.id === item.productId
                                  )
                                  .map((item) => (
                                    <div
                                      key={item.productId}
                                      className="relative"
                                    >
                                      <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        value={item.allocation}
                                        onChange={(e) =>
                                          handleProductAllocationChange(
                                            item.productId,
                                            e.target.value,
                                            category.id,
                                            false
                                          )
                                        }
                                        onBlur={(e) => {
                                          const value = parseFloat(
                                            e.target.value
                                          );
                                          if (!isNaN(value)) {
                                            handleProductAllocationChange(
                                              item.productId,
                                              value.toFixed(2),
                                              category.id,
                                              false
                                            );
                                          }
                                        }}
                                        className={`w-full md:w-30 text-sm bg-white px-3 py-3 rounded-xl shadow-sm text-black 
            focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
              errors[subcategory.id] ? "border-[#FF5050] border-2" : "border"
            }`}
                                      />
                                      <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                        %
                                      </span>
                                    </div>
                                  ))}
                              </div>

                              {/* Empty Placeholder for Alignment */}
                              <div className="hidden md:block text-md font-bold text-black"></div>

                              {/* Delete Button (Only for strategyTypeId === 1) */}
                              {strategyTypeId == 1 && (
                                <button
                                  className="text-black ml-[25vw] md:ml-0 font-bold border-2 border-black rounded-full px-2 py-0
      hover:bg-black hover:text-white transition-all duration-200"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    DeleteProduct(category.id, subcategory.id);
                                  }}
                                >
                                  &times;
                                </button>
                              )}

                              {/* Empty Placeholder (for Alignment when strategyTypeId !== 1) */}
                              {strategyTypeId != 1 && (
                                <div className="hidden md:block text-md font-bold text-black"></div>
                              )}
                            </div>

                            {/* <span className="text-sm md:text-lg w-80 font-semibold text-black">
                                {`${subcategoryIndex + 1}. ${subcategory.name}`}
                              </span>
                              {productCodes
                                .filter(
                                  (item) => subcategory.id === item.productId
                                )
                                .map((item, itemIndex, filteredStocks) => (
                                  <div className="relative ml-14">
                                    <input
                                      type="number"
                                      step="0.01"
                                      min="0"
                                      max="100"
                                      // disabled={
                                      //   item.productId == 9 ? true : false
                                      // }
                                      value={item.allocation.toFixed(2)}
                                      onChange={(e) =>
                                        handleProductAllocationChange(
                                          item.productId,
                                          e.target.value,
                                          category.id
                                        )
                                      }
                                      className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                    />
                                    <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                      %
                                    </span>
                                  </div>
                                ))} */}
                            <span className="text-sm md:text-lg font-semibold text-black"></span>
                          </div>
                        </div>
                        {errors[subcategory.id] && (
                          <div>
                            {productCodes
                              .filter(
                                (item) => subcategory.id === item.productId
                              )
                              .map((item, itemIndex, filteredStocks) => (
                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                  <div className="flex  items-center">
                                    <img
                                      src="/danger.svg"
                                      alt="Arrow"
                                      className=" left-0 w-5 h-5 mr-2"
                                    />{" "}
                                    Product Sub Allocation should be equal to{" "}
                                    {Number(item.allocation).toFixed(2)}%
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                        {twoPercentErrors[subcategory.id] && (
                          <div>
                            {productCodes
                              .filter(
                                (item) => subcategory.id === item.productId
                              )
                              .map((item, itemIndex, filteredStocks) => (
                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                  <div className="flex  items-center">
                                    <img
                                      src="/danger.svg"
                                      alt="Arrow"
                                      className=" left-0 w-5 h-5 mr-2"
                                    />{" "}
                                    Australian Cash should be atleast 2%
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                        {/* Table of Items */}
                        <div className="ml-6 pl-0" style={{ height: "50%" }}>
                          <div
                            onScroll={handleScroll}
                            className={`relative overflow-x-auto ${
                              !isAnyDropdownOpen ? "" : ""
                            }`}
                          >
                            <table className="min-w-full h-full table-auto border-collapse">
                              <tbody className="rounded-md">
                                {stocks
                                  .filter((item) => item.product !== 9)
                                  .filter(
                                    (item) => subcategory.id === item.product
                                  )
                                  .map((item, itemIndex, filteredStocks) => (
                                    <tr
                                      key={itemIndex}
                                      className="text-left w-full mt-3  rounded-xl"
                                    >
                                      {itemIndex >= 0 && (
                                        <td
                                          className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${itemIndex === stocks.length - 1 ? "" : ""}`}
                                        >
                                          {itemIndex ===
                                          filteredStocks.length - 1 ? (
                                            <div
                                              className={`absolute left-0 top-0  w-[2px]  ${
                                                category.id === 2
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                              style={{
                                                height: "60%", // 60% of the parent height
                                              }}
                                            ></div>
                                          ) : (
                                            <div
                                              className={`absolute left-0 top-0 h-full w-[2px] ${
                                                category.id === 2
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                            ></div>
                                          )}
                                          {category.id === 2 ? (
                                            <img
                                              src="/green-arrow.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          ) : (
                                            <img
                                              src="/arrow-hierarchy.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          )}
                                        </td>
                                      )}
                                      <div className="mt-2">
                                        <td
                                          className={`py-2 h-full w-40 py-2 rounded-l-lg mt-2 px-2 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          {`${String.fromCharCode(
                                            97 + itemIndex
                                          )}`}
                                          . {/* Item Number (a, b, c) */}
                                        </td>
                                        <td
                                          className={`pt-2 relative w-50 py-2 px-4 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <button
                                            ref={(el) =>
                                              (buttonRefs.current[
                                                `${subcategory.id}-${itemIndex}`
                                              ] = el)
                                            } // Assign unique ref
                                            onClick={() => {
                                              toggleDropdown(
                                                itemIndex,
                                                subcategory.id
                                              );
                                            }}
                                            className="px-4 py-2 text-sm font-medium rounded-xl   bg-white border flex items-center justify-start gap-2 focus:outline-none focus:ring-2 focus:ring-black"
                                          >
                                            <span className="w-20">
                                              {item.code}
                                            </span>
                                            <img
                                              src="/cross-grey.svg" // Replace with the correct path to your cross image
                                              alt="Close"
                                              className="w-2 h-2 ml-4"
                                            />
                                          </button>
                                          <DropdownTest
                                            isOpen={
                                              dropdownOpen[
                                                `${subcategory.id}-${itemIndex}`
                                              ]
                                            }
                                            buttonRef={
                                              buttonRefs.current[
                                                `${subcategory.id}-${itemIndex}`
                                              ]
                                            } // Pass unique ref to the dropdown
                                          >
                                            <div className="absolute z-50 mt-2 w-30 bg-white rounded-md shadow-lg">
                                              <div
                                                ref={searchRef}
                                                className="p-2"
                                              >
                                                <input
                                                  type="text"
                                                  value={searchTerm}
                                                  onChange={(e) =>
                                                    setSearchTerm(
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Search..."
                                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                                />
                                              </div>
                                              <div className="p-4  w-40 overflow-y-auto max-h-40">
                                                <ul className="space-y-2">
                                                  {getRelevantSecurityCodes(
                                                    category.id,
                                                    subcategory.id
                                                  )
                                                    .filter((option) =>
                                                      option.stock.asx_code
                                                        .toLowerCase()
                                                        .includes(
                                                          searchTerm.toLowerCase()
                                                        )
                                                    )
                                                    .map(
                                                      (option, optionIndex) => (
                                                        <li
                                                          onClick={() => {
                                                            handleCodeChange(
                                                              itemIndex,
                                                              subcategoryIndex,
                                                              categoryIndex,
                                                              option.stock
                                                                .asx_code
                                                            );
                                                            setDropdownOpen(
                                                              (prevState) => ({
                                                                ...prevState,
                                                                [`${subcategory.id}-${itemIndex}`]:
                                                                  !prevState[
                                                                    `${subcategory.id}-${itemIndex}`
                                                                  ],
                                                              })
                                                            );
                                                            setSearchTerm("");
                                                            setisAnyDropdownOpen(
                                                              !isAnyDropdownOpen
                                                            );
                                                          }}
                                                          key={optionIndex}
                                                          className="flex justify-between items-center  px-4 py-2 text-sm text-black rounded-lg hover:bg-black hover:text-white  cursor-pointer"
                                                        >
                                                          {
                                                            option.stock
                                                              .asx_code
                                                          }
                                                        </li>
                                                      )
                                                    )}
                                                </ul>
                                              </div>
                                            </div>
                                          </DropdownTest>
                                        </td>
                                        <td
                                          className={`py-2 px-4 w-3/4  ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                            {item.name}
                                          </span>
                                        </td>
                                        <td
                                          className={`py-2 relative w-50 px-4 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <div className="relative ml-2">
                                            <input
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              max="100"
                                              value={item.allocation}
                                              onChange={(e) =>
                                                handleStockAllocationChange(
                                                  item.id,
                                                  e.target.value,
                                                  item.stockId
                                                )
                                              }
                                              onBlur={(e) => {
                                                const value = parseFloat(
                                                  e.target.value
                                                );
                                                if (!isNaN(value)) {
                                                  handleStockAllocationChange(
                                                    item.id,
                                                    value.toFixed(2),
                                                    item.stockId
                                                  );
                                                }
                                              }}
                                              className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                            />
                                            <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                              %
                                            </span>
                                          </div>
                                        </td>
                                        <td
                                          className={`py-4 px-4 w-3/4 font-semibold text-md text-black ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <span className="ml-4">
                                            {" "}
                                            {item.stockMarketPrice
                                              .toFixed(2)
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              )}
                                          </span>
                                        </td>
                                        <td
                                          className={`py-4 px-4 w-3/4 rounded-r-lg ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          {/* Delete Button */}
                                          <button
                                            className="text-black text-bold border-2 border-black rounded-full px-2 mr-4 py-0 hover:text-black"
                                            onClick={(e) => {
                                              e.stopPropagation(); // Prevent triggering the dropdown toggle
                                              deleteStock(
                                                item.id,
                                                item.stockId
                                              );
                                            }}
                                          >
                                            &times;{" "}
                                          </button>
                                        </td>
                                      </div>
                                    </tr>
                                  ))}
                                {subcategory.id != 9 && (
                                  <tr className="text-left rounded-xl">
                                    <td
                                      colSpan="8"
                                      className="py-2 w-full pl-3"
                                    >
                                      <div
                                        className={`flex justify-center py-2 rounded-lg bg-[#F8FCFF] border-2 border-dashed  items-center ${
                                          category.id === 2
                                            ? "text-[#A9D4AB]"
                                            : "text-[#92C5EA]"
                                        }`}
                                      >
                                        <button
                                          className="flex items-center gap-2 px-6 py-2 bg-white text-[#92C5EA] rounded-lg shadow-sm  focus:outline-none focus:ring-2 focus:ring-[#BBDBF2]"
                                          onClick={() =>
                                            handleAddItem(
                                              subcategory.id,
                                              category.id,
                                              subcategory.stocks,
                                              subcategoryIndex
                                            )
                                          }
                                        >
                                          {category.id === 2 ? (
                                            <img
                                              src="/add-green.svg"
                                              alt="Add Icon"
                                              className="w-5 h-5"
                                            />
                                          ) : (
                                            <img
                                              src="/add-me.svg"
                                              alt="Add Icon"
                                              className="w-5 h-5"
                                            />
                                          )}

                                          <span
                                            className={`text-sm ${
                                              category.id === 2
                                                ? "text-[#A9D4AB]"
                                                : "text-[#92C5EA]"
                                            }`}
                                          >
                                            Add Security
                                          </span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                {totalErrors[category.id] && (
                  <div>
                    {categoryCodes
                      .filter((item) => category.id === item.categoryId)
                      .map((item, itemIndex, filteredStocks) => (
                        <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                          <div className="flex  items-center">
                            <img
                              src="/danger.svg"
                              alt="Arrow"
                              className=" left-0 w-5 h-5 mr-2"
                            />{" "}
                            Sub Allocation should be equal to{" "}
                            {item.categoryId == 1
                              ? growth == 100
                                ? (
                                    growth - australianCashStockAllocation
                                  ).toFixed(2)
                                : growth.toFixed(2)
                              : defensive.toFixed(2)}
                            %
                          </div>
                        </div>
                      ))}
                  </div>
                )}
                {expandedCategory[category.id] && (
                  <div
                    className={`flex items-center p-4 mt-4 border rounded-md ${
                      category.id === 2
                        ? "border-[#A9D4AB]"
                        : "border-[#92C5EA]"
                    }`}
                  >
                    {categoryCodes
                      .filter((item) => category.id === item.categoryId)
                      .map((item, itemIndex, filteredStocks) => (
                        <div
                          key={itemIndex}
                          className="flex items-center justify-between w-full"
                        >
                          <div className="text-sm sub-cat md:text-md font-bold text-black">
                            SUB-TOTAL {category.name}
                          </div>

                          <div className="text-sm md:text-md font-bold text-black"></div>
                          <div className="text-sm md:text-md ml-custom font-bold text-black">
                            {item.allocation.toFixed(2)} %
                          </div>
                          <div className="text-sm md:text-md font-bold text-black"></div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ))}
            {parseFloat(Number(totalPortfolio).toFixed(2)) != 100.0 && (
              <div>
                <div className=" flex mb-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                  <div className="flex  items-center">
                    <img
                      src="/danger.svg"
                      alt="Arrow"
                      className=" left-0 w-5 h-5 mr-2"
                    />{" "}
                    Total Portfolio Allocation should be equal to 100%
                  </div>
                </div>
              </div>
            )}
            <div className="flex items-center p-4 border rounded-md border-black">
              <div className="flex items-center justify-between w-full">
                <div className="text-sm  sub-cat md:text-md font-bold text-black">
                  TOTAL PORTFOLIO
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>

                <div className="text-sm md:text-md ml-custom font-bold text-black">
                  {Number(totalPortfolio).toFixed(2)} %
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>
              </div>
            </div>
          </div>
        )}
        {riskProfile && Number(minimumInvestment) > 0 && isNew == false && (
          <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
              <h1 className="text-lg font-medium mb-2 text-black text-center">
                Current Target Allocation
              </h1>
              <img
                onClick={togglePopupEditStock}
                src="/edit-details.svg" // Replace with the actual path to your edit icon
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            {isOpenEditStock && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[70%] md:w-[500px] p-6">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Add New Stock
                    </h2>
                    <button onClick={togglePopupEditStock}>
                      <img src="/add.svg" alt="Close" className="w-10 h-10" />
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex flex-col mx-auto max-w-sm w-full">
                      <label
                        htmlFor="stockCode"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Stock Code
                      </label>
                      <input
                        id="stockCode"
                        type="text"
                        value={newStockCode}
                        onChange={(e) => setNewStockCode(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder="SMA"
                      />
                      <label
                        htmlFor="stockName"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Stock Name
                      </label>
                      <input
                        id="stockName"
                        type="text"
                        value={stockName}
                        onChange={(e) => setStockName(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder=""
                      />
                      <label
                        htmlFor="volatility"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Volatility
                      </label>
                      <input
                        id="volatility"
                        type="text"
                        value={volatility}
                        onChange={(e) => setVolatility(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder="SMA"
                      />
                    </div>
                    {/* Risk type */}
                    <div className="flex flex-col mx-auto max-w-sm w-full">
                      <div className="mt-4">
                        <Dropdown
                          label="Product"
                          options={productData}
                          onSelect={handleSelectProductType}
                        />
                      </div>
                      <label
                        htmlFor="stockExchange"
                        className="mb-1 mt-4 text-sm text-labelColour block"
                      >
                        Exchange
                      </label>
                      <input
                        id="stockExchange"
                        type="text"
                        value={newStockExchange}
                        onChange={(e) => setNewStockExchange(e.target.value)}
                        className="p-2 text-black font-medium border border-gray-300 rounded-md text-md w-full"
                        placeholder="SMA"
                      />
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="flex justify-center space-x-4 mt-6">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          newStockCode == "" ||
                          stockName == "" ||
                          productType == "" ||
                          newStockExchange == "" ||
                          volatility == ""
                        ) {
                          showToast("Please fill all fields", "error");
                          return;
                        }
                        setLoading(true);
                        handleStockProductType(e);
                      }}
                      className="px-8 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                    >
                      Add Stock
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Table Header */}
            <div className="overflow-x-auto ml-4 mb-4">
              <table className=" w-full table-auto border-collapse">
                <thead>
                  <tr className="pl-14">
                    <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                      No
                    </th>
                    <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                      Security (Code)
                    </th>
                    <th className="py-2 px-2 text-sm w-60 font-medium text-[#8C8C8C] border-b">
                      Name
                    </th>
                    <th className="py-2 pl-10  text-sm font-medium text-[#8C8C8C] border-b">
                      Allocation (%)
                    </th>
                    <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b">
                      Market Price (AUD)
                    </th>
                  </tr>
                </thead>
              </table>
            </div>

            {/* Categories */}
            {newCategories.map((category, categoryIndex) => (
              <div key={category.id} className="mb-2">
                <div
                  className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                    category.id === 2 ? "bg-[#A9D4AB]" : "bg-[#92C5EA]"
                  }`}
                >
                  <div
                    className="flex items-center flex-grow cursor-pointer"
                    onClick={() => toggleExpandCategory(category.id)}
                  >
                    <span className="text-sm md:text-lg font-bold text-black">
                      {category.name}{" "}
                      <span className="font-medium">
                        {category.id === 2
                          ? `(${defensive.toFixed(2)}%)`
                          : `(${growth.toFixed(2)}%)`}
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="relative mt-2">
                      <button
                        onClick={() =>
                          toggleCategoryDropdown(category.id, categoryIndex)
                        }
                        className={`flex items-center text-sm text-white p-3 rounded-xl transition-all ${
                          category.id === 2 ? "bg-[#709D72]" : "bg-[#63859F] "
                        }`}
                      >
                        <FaPlus className="mr-2 " /> Add Asset Category{" "}
                      </button>
                      {isDropdownOpen(category.id, categoryIndex) && (
                        <div className="absolute z-50 mt-2 bg-white border rounded-md shadow-lg w-full">
                          {actualCategories
                            .filter(
                              (categoryItem) => categoryItem.id === category.id
                            ) // Match category ID
                            .flatMap((categoryItem) => categoryItem.products) // Extract products from matching categories
                            .filter(
                              (p) =>
                                !(
                                  selectedProductsByCategory[category.id] || []
                                ).includes(p.id) // Exclude selected products
                            )
                            .map((filteredProduct) => (
                              <div
                                key={filteredProduct.id}
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                onClick={() => {
                                  toggleCategoryDropdown(
                                    category.id,
                                    categoryIndex
                                  );
                                  toggleProduct(
                                    category.id,
                                    filteredProduct.id
                                  );
                                  if (!expandedCategory[category.id]) {
                                    toggleExpandCategory(category.id);
                                  }
                                }}
                              >
                                {filteredProduct.name}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                    <span
                      className="cursor-pointer lg:ml-4 ml-0"
                      onClick={() => toggleExpandCategory(category.id)}
                    >
                      {expandedCategory[category.id] ? (
                        <img
                          src="/export-arrow.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>

                {/* Subcategories */}
                <div
                  className={`ml-4 md:ml-6 border-l-2 ${
                    category.id === 2 ? "border-[#A9D4AB]" : "border-[#92C5EA]"
                  }`}
                >
                  {category.products
                    .filter((product) =>
                      (selectedProductsByCategory[category.id] || []).includes(
                        product.id
                      )
                    )

                    .map((subcategory, subcategoryIndex) => (
                      <div
                        key={subcategory.name}
                        className="relative mb-2 pt-2 text-left"
                      >
                        {/* Subcategory Header */}
                        <div className="flex items-center justify-start  rounded-md cursor-pointer">
                          {category.id === 2 ? (
                            <img
                              src="/green-arrow.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          ) : (
                            <img
                              src="/arrow-hierarchy.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          )}

                          <div
                            className={`flex items-center justify-between p-4 w-full  rounded-md cursor-pointer ${
                              category.id === 2
                                ? "bg-[#C0E2C1]"
                                : "bg-[#C6DFF1] "
                            }`}
                          >
                            <div
                              key={subcategory.name}
                              className="flex flex-wrap md:flex-nowrap items-center justify-between w-full space-y-4 md:space-y-0 md:space-x-6"
                            >
                              {/* Subcategory Name */}
                              <div
                                className={`text-sm md:text-lg w-full custom-create-margin md:w-1/3 font-bold text-black 
    ${strategyTypeId == 1 ? "md:mr-[8.5vw] new-ml" : "md:mr-[7vw] ml-st "}`}
                              >
                                {`${subcategoryIndex + 1}. ${subcategory.name}`}
                              </div>

                              {/* Empty Placeholder for Alignment */}
                              <div className="hidden md:block text-md font-bold text-black"></div>

                              {/* Input Field with Percentage */}
                              <div className="w-full md:w-auto relative">
                                {productCodes
                                  .filter(
                                    (item) => subcategory.id === item.productId
                                  )
                                  .map((item) => (
                                    <div
                                      key={item.productId}
                                      className="relative"
                                    >
                                      <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        value={item.allocation}
                                        onChange={(e) =>
                                          handleProductAllocationChange(
                                            item.productId,
                                            e.target.value,
                                            category.id,
                                            false
                                          )
                                        }
                                        onBlur={(e) => {
                                          const value = parseFloat(
                                            e.target.value
                                          );
                                          if (!isNaN(value)) {
                                            handleProductAllocationChange(
                                              item.productId,
                                              value.toFixed(2),
                                              category.id,
                                              false
                                            );
                                          }
                                        }}
                                        className={`w-full md:w-30 text-sm bg-white px-3 py-3 rounded-xl shadow-sm text-black 
            focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
              errors[subcategory.id] ? "border-[#FF5050] border-2" : "border"
            }`}
                                      />
                                      <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                        %
                                      </span>
                                    </div>
                                  ))}
                              </div>

                              {/* Empty Placeholder for Alignment */}
                              <div className="hidden md:block text-md font-bold text-black"></div>

                              {/* Delete Button (Only for strategyTypeId === 1) */}
                              {strategyTypeId == 1 && (
                                <button
                                  className="text-black ml-[25vw] md:ml-0 font-bold border-2 border-black rounded-full px-2 py-0
      hover:bg-black hover:text-white transition-all duration-200"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    DeleteProduct(category.id, subcategory.id);
                                  }}
                                >
                                  &times;
                                </button>
                              )}

                              {/* Empty Placeholder (for Alignment when strategyTypeId !== 1) */}
                              {strategyTypeId != 1 && (
                                <div className="hidden md:block text-md font-bold text-black"></div>
                              )}
                            </div>

                            {/* <span className="text-sm md:text-lg w-80 font-semibold text-black">
                                {`${subcategoryIndex + 1}. ${subcategory.name}`}
                              </span>
                              {productCodes
                                .filter(
                                  (item) => subcategory.id === item.productId
                                )
                                .map((item, itemIndex, filteredStocks) => (
                                  <div className="relative ml-14">
                                    <input
                                      type="number"
                                      step="0.01"
                                      min="0"
                                      max="100"
                                      // disabled={
                                      //   item.productId == 9 ? true : false
                                      // }
                                      value={item.allocation.toFixed(2)}
                                      onChange={(e) =>
                                        handleProductAllocationChange(
                                          item.productId,
                                          e.target.value,
                                          category.id
                                        )
                                      }
                                      className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                    />
                                    <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                      %
                                    </span>
                                  </div>
                                ))} */}
                            <span className="text-sm md:text-lg font-semibold text-black"></span>
                          </div>
                        </div>
                        {errors[subcategory.id] && (
                          <div>
                            {productCodes
                              .filter(
                                (item) =>
                                  item.productId !== 10 &&
                                  subcategory.id === item.productId
                              )
                              .map((item, itemIndex, filteredStocks) => (
                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                  <div className="flex  items-center">
                                    <img
                                      src="/danger.svg"
                                      alt="Arrow"
                                      className=" left-0 w-5 h-5 mr-2"
                                    />{" "}
                                    Product Sub Allocation should be equal to{" "}
                                    {Number(item.allocation).toFixed(2)}%
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                        {twoPercentErrors[subcategory.id] && (
                          <div>
                            {productCodes
                              .filter(
                                (item) => subcategory.id === item.productId
                              )
                              .map((item, itemIndex, filteredStocks) => (
                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                  <div className="flex  items-center">
                                    <img
                                      src="/danger.svg"
                                      alt="Arrow"
                                      className=" left-0 w-5 h-5 mr-2"
                                    />{" "}
                                    Australian Cash should be atleast 2%
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                        {/* Table of Items */}
                        <div className="ml-6 pl-0" style={{ height: "50%" }}>
                          <div
                            onScroll={handleScroll}
                            className={`relative overflow-x-auto ${
                              !isAnyDropdownOpen ? "" : ""
                            }`}
                          >
                            <table className="min-w-full h-full table-auto border-collapse">
                              <tbody className="rounded-md">
                                {stocks
                                  .filter((item) => item.product !== 9)
                                  .filter(
                                    (item) => subcategory.id === item.product
                                  )
                                  .map((item, itemIndex, filteredStocks) => (
                                    <tr
                                      key={itemIndex}
                                      className="text-left w-full mt-3  rounded-xl"
                                    >
                                      {itemIndex >= 0 && (
                                        <td
                                          className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${itemIndex === stocks.length - 1 ? "" : ""}`}
                                        >
                                          {itemIndex ===
                                          filteredStocks.length - 1 ? (
                                            <div
                                              className={`absolute left-0 top-0  w-[2px]  ${
                                                category.id === 2
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                              style={{
                                                height: "60%", // 60% of the parent height
                                              }}
                                            ></div>
                                          ) : (
                                            <div
                                              className={`absolute left-0 top-0 h-full w-[2px] ${
                                                category.id === 2
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                            ></div>
                                          )}
                                          {category.id === 2 ? (
                                            <img
                                              src="/green-arrow.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          ) : (
                                            <img
                                              src="/arrow-hierarchy.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          )}
                                        </td>
                                      )}
                                      <div className="mt-2">
                                        <td
                                          className={`py-2 h-full w-40 py-2 rounded-l-lg mt-2 px-2 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          {`${String.fromCharCode(
                                            97 + itemIndex
                                          )}`}
                                          . {/* Item Number (a, b, c) */}
                                        </td>
                                        <td
                                          className={`pt-2 relative w-50 py-2 px-4 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <button
                                            ref={(el) =>
                                              (buttonRefs.current[
                                                `${subcategory.id}-${itemIndex}`
                                              ] = el)
                                            } // Assign unique ref
                                            onClick={() => {
                                              toggleDropdown(
                                                itemIndex,
                                                subcategory.id
                                              );
                                            }}
                                            className="px-4 py-2 text-sm font-medium rounded-xl   bg-white border flex items-center justify-start gap-2 focus:outline-none focus:ring-2 focus:ring-black"
                                          >
                                            <span className="w-20">
                                              {item.code}
                                            </span>
                                            <img
                                              src="/cross-grey.svg" // Replace with the correct path to your cross image
                                              alt="Close"
                                              className="w-2 h-2 ml-4"
                                            />
                                          </button>
                                          <DropdownTest
                                            isOpen={
                                              dropdownOpen[
                                                `${subcategory.id}-${itemIndex}`
                                              ]
                                            }
                                            buttonRef={
                                              buttonRefs.current[
                                                `${subcategory.id}-${itemIndex}`
                                              ]
                                            } // Pass unique ref to the dropdown
                                          >
                                            <div className="absolute z-50 mt-2 w-30 bg-white rounded-md shadow-lg">
                                              <div
                                                ref={searchRef}
                                                className="p-2"
                                              >
                                                <input
                                                  type="text"
                                                  value={searchTerm}
                                                  onChange={(e) =>
                                                    setSearchTerm(
                                                      e.target.value
                                                    )
                                                  }
                                                  placeholder="Search..."
                                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                                />
                                              </div>
                                              <div className="p-4  w-40 overflow-y-auto max-h-40">
                                                <ul className="space-y-2">
                                                  {getRelevantSecurityCodes(
                                                    category.id,
                                                    subcategory.id
                                                  )
                                                    .filter((option) =>
                                                      option.stock.asx_code
                                                        .toLowerCase()
                                                        .includes(
                                                          searchTerm.toLowerCase()
                                                        )
                                                    )
                                                    .map(
                                                      (option, optionIndex) => (
                                                        <li
                                                          onClick={() => {
                                                            handleCodeChange(
                                                              itemIndex,
                                                              subcategoryIndex,
                                                              categoryIndex,
                                                              option.stock
                                                                .asx_code
                                                            );
                                                            setDropdownOpen(
                                                              (prevState) => ({
                                                                ...prevState,
                                                                [`${subcategory.id}-${itemIndex}`]:
                                                                  !prevState[
                                                                    `${subcategory.id}-${itemIndex}`
                                                                  ],
                                                              })
                                                            );
                                                            setSearchTerm("");
                                                            setisAnyDropdownOpen(
                                                              !isAnyDropdownOpen
                                                            );
                                                          }}
                                                          key={optionIndex}
                                                          className="flex justify-between items-center  px-4 py-2 text-sm text-black rounded-lg hover:bg-black hover:text-white  cursor-pointer"
                                                        >
                                                          {
                                                            option.stock
                                                              .asx_code
                                                          }
                                                        </li>
                                                      )
                                                    )}
                                                </ul>
                                              </div>
                                            </div>
                                          </DropdownTest>
                                        </td>
                                        <td
                                          className={`py-2 px-4 w-3/4  ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                            {item.name}
                                          </span>
                                        </td>
                                        <td
                                          className={`py-2 relative w-50 px-4 ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <div className="relative ml-2">
                                            <input
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              max="100"
                                              value={item.allocation}
                                              onChange={(e) =>
                                                handleStockAllocationChange(
                                                  item.id,
                                                  e.target.value,
                                                  item.stockId
                                                )
                                              }
                                              onBlur={(e) => {
                                                const value = parseFloat(
                                                  e.target.value
                                                );
                                                if (!isNaN(value)) {
                                                  handleStockAllocationChange(
                                                    item.id,
                                                    value.toFixed(2),
                                                    item.stockId
                                                  );
                                                }
                                              }}
                                              className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                            />
                                            <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                              %
                                            </span>
                                          </div>
                                        </td>
                                        <td
                                          className={`py-4 px-4 w-3/4 font-semibold text-md text-black ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          <span className="ml-4">
                                            {" "}
                                            {item.stockMarketPrice
                                              .toFixed(2)
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              )}
                                          </span>
                                        </td>
                                        <td
                                          className={`py-4 px-4 w-3/4 rounded-r-lg ${
                                            category.id === 2
                                              ? "bg-[#E7F5E8]"
                                              : "bg-[#E6F3FC]"
                                          }`}
                                        >
                                          {/* Delete Button */}
                                          <button
                                            className="text-black text-bold border-2 border-black rounded-full px-2 mr-4 py-0 hover:text-black"
                                            onClick={(e) => {
                                              e.stopPropagation(); // Prevent triggering the dropdown toggle
                                              deleteStock(
                                                item.id,
                                                item.stockId
                                              );
                                            }}
                                          >
                                            &times;{" "}
                                          </button>
                                        </td>
                                      </div>
                                    </tr>
                                  ))}
                                {subcategory.id != 9 && (
                                  <tr className="text-left rounded-xl">
                                    <td
                                      colSpan="8"
                                      className="py-2 w-full pl-3"
                                    >
                                      <div
                                        className={`flex justify-center py-2 rounded-lg bg-[#F8FCFF] border-2 border-dashed  items-center ${
                                          category.id === 2
                                            ? "text-[#A9D4AB]"
                                            : "text-[#92C5EA]"
                                        }`}
                                      >
                                        <button
                                          className="flex items-center gap-2 px-6 py-2 bg-white text-[#92C5EA] rounded-lg shadow-sm  focus:outline-none focus:ring-2 focus:ring-[#BBDBF2]"
                                          onClick={() =>
                                            handleAddItem(
                                              subcategory.id,
                                              category.id,
                                              subcategory.stocks,
                                              subcategoryIndex
                                            )
                                          }
                                        >
                                          {category.id === 2 ? (
                                            <img
                                              src="/add-green.svg"
                                              alt="Add Icon"
                                              className="w-5 h-5"
                                            />
                                          ) : (
                                            <img
                                              src="/add-me.svg"
                                              alt="Add Icon"
                                              className="w-5 h-5"
                                            />
                                          )}

                                          <span
                                            className={`text-sm ${
                                              category.id === 2
                                                ? "text-[#A9D4AB]"
                                                : "text-[#92C5EA]"
                                            }`}
                                          >
                                            Add Security
                                          </span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                {totalErrors[category.id] && (
                  <div>
                    {categoryCodes
                      .filter((item) => category.id === item.categoryId)
                      .map((item, itemIndex, filteredStocks) => (
                        <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                          <div className="flex  items-center">
                            <img
                              src="/danger.svg"
                              alt="Arrow"
                              className=" left-0 w-5 h-5 mr-2"
                            />{" "}
                            Sub Allocation should be equal to{" "}
                            {item.categoryId == 1
                              ? growth == 100
                                ? (
                                    growth - australianCashStockAllocation
                                  ).toFixed(2)
                                : growth.toFixed(2)
                              : defensive.toFixed(2)}
                            %
                          </div>
                        </div>
                      ))}
                  </div>
                )}
                {expandedCategory[category.id] && (
                  <div
                    className={`flex items-center p-4 mt-4 border rounded-md ${
                      category.id === 2
                        ? "border-[#A9D4AB]"
                        : "border-[#92C5EA]"
                    }`}
                  >
                    {categoryCodes
                      .filter((item) => category.id === item.categoryId)
                      .map((item, itemIndex, filteredStocks) => (
                        <div
                          key={itemIndex}
                          className="flex items-center justify-between w-full"
                        >
                          <div className="text-sm sub-cat md:text-md font-bold text-black">
                            SUB-TOTAL {category.name}
                          </div>

                          <div className="text-sm md:text-md font-bold text-black"></div>
                          <div className="text-sm md:text-md ml-custom font-bold text-black">
                            {Number(item.allocation).toFixed(2)} %
                          </div>
                          <div className="text-sm md:text-md font-bold text-black"></div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ))}
            {parseFloat(Number(totalPortfolio).toFixed(2)) != 100.0 && (
              <div>
                <div className=" flex mb-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                  <div className="flex  items-center">
                    <img
                      src="/danger.svg"
                      alt="Arrow"
                      className=" left-0 w-5 h-5 mr-2"
                    />{" "}
                    Total Portfolio Allocation should be equal to 100%
                  </div>
                </div>
              </div>
            )}
            <div className="flex items-center p-4 border rounded-md border-black">
              <div className="flex items-center justify-between w-full">
                <div className="text-sm  sub-cat md:text-md font-bold text-black">
                  TOTAL PORTFOLIO
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>

                <div className="text-sm md:text-md ml-custom font-bold text-black">
                  {Number(totalPortfolio).toFixed(2)} %
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>
              </div>
            </div>
          </div>
        )}
        {parseFloat(Number(totalPortfolio).toFixed(2)) == 100.0 && (
          <div className="bg-white mt-6 p-6 shadow-md rounded-md">
            <PerformanceSection
              riskProfile={investmentProductName}
              data={productCodes}
              stockCode={stocks}
              totalPercentage={totalPortfolio}
              componentName="create"
            />
          </div>
        )}
        <OtherDetails
          setperformanceNote={setperformanceNote}
          setdisclaimer={setdisclaimer}
          setcopyrights={setcopyrights}
          setaddToDashboard={setaddToDashboard}
          setaddMember={setaddMember}
          showAll={true}
          preselectedAddToDashboard={preselectedAddToDashboard}
          preselectedAddUser={preselectedAddUser}
          prePerformanceNotes={performanceNotes}
          preDisclaimer={disclaimer}
          preCopyright={copyrights}
        />
        {addMember && <AccessibleTable />}
        <DocumentsSection />
        <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
          <div className="flex items-center justify-end w-full space-x-4">
            <div
              onClick={(e) => {
                e.preventDefault();
                if (Number(minimumInvestment) <= 0) {
                  showToast("Please Add Minimum Investment Amount", "error");
                  return;
                }
                if (!strategyType) {
                  showToast("Please Select Strategy", "error");
                  return;
                }
                if (!riskProfile) {
                  showToast("Please Select Risk Profile", "error");
                  return;
                }
                if (!investmentManagerId) {
                  showToast("Please Select Investment Manager", "error");
                  return;
                }
                if (!InvestmentManagerAccount) {
                  showToast("Please Select Manager's Account", "error");
                  return;
                }
                if (!platformId) {
                  showToast(" Please Select Platform", "error");
                  return;
                }
                if (!platformWalletId) {
                  showToast("Please Select Platform's Account", "error");
                  return;
                }

                if (
                  Object.keys(errors).length !== 0 ||
                  Object.keys(totalErrors).length !== 0
                ) {
                  showToast("Please set your allocated stock", "error");
                  return;
                }
                if (Object.keys(twoPercentErrors).length !== 0) {
                  showToast("Please set Australian cash atleast 2%", "error");
                  return;
                }
                if (parseFloat(Number(totalPortfolio).toFixed(2)) != 100.0) {
                  showToast("Portfolio Allocation should be 100%", "error");
                  return;
                }
                if (
                  !stocks.some(
                    (item) =>
                      item.product === 9 &&
                      item.stockId === 93 &&
                      item.allocation >= 2
                  )
                ) {
                  showToast("Please add Platform Cash", "error");
                  return;
                }
                if (!creationDate) {
                  showToast("Please Select Strategy Creation Date", "error");
                  return;
                }
                if (!investmentProductName) {
                  showToast("Please Enter Investment Product Name", "error");
                  return;
                }
                setLoading(true);
                handleCreateInvestment(e);
              }}
              className="text-sm md:text-md cursor-pointer font-medium py-1 px-8 rounded-full bg-white text-black"
            >
              Save
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                if (Number(minimumInvestment) <= 0) {
                  showToast("Please Add Minimum Investment Amount", "error");
                  return;
                }
                if (!strategyType) {
                  showToast("Please Select Strategy", "error");
                  return;
                }
                if (!riskProfile) {
                  showToast("Please Select Risk Profile", "error");
                  return;
                }
                if (!investmentManagerId) {
                  showToast("Please Select Investment Manager", "error");
                  return;
                }
                if (!InvestmentManagerAccount) {
                  showToast("Please Select Manager's Account", "error");
                  return;
                }
                if (!platformId) {
                  showToast("Please Select Platform", "error");
                  return;
                }
                if (!platformWalletId) {
                  showToast("Please Select Platform's Account", "error");
                  return;
                }

                if (
                  Object.keys(errors).length !== 0 ||
                  Object.keys(totalErrors).length !== 0
                ) {
                  showToast("Please set your allocated stock", "error");
                  return;
                }
                if (Object.keys(twoPercentErrors).length !== 0) {
                  showToast("Please set Australian cash atleast 2%", "error");
                  return;
                }
                if (parseFloat(Number(totalPortfolio).toFixed(2)) != 100.0) {
                  showToast("Portfolio Allocation should be 100%", "error");
                  return;
                }
                if (
                  !stocks.some(
                    (item) =>
                      item.product === 9 &&
                      item.stockId === 93 &&
                      item.allocation >= 2
                  )
                ) {
                  showToast("Please add Platform Cash", "error");
                  return;
                }
                if (!creationDate) {
                  showToast("Please Select Strategy Creation Date", "error");
                  return;
                }
                setLoading(true);
                handleCreateAndSubmitInvestment(e);
              }}
              className="text-sm md:text-md cursor-pointer font-medium py-1 px-8 rounded-full bg-white text-black"
            >
              Save & Submit
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInvestment;
